<template>
<div class="page">
  <!-- 问卷列表页面 -->
  <div class="survey" v-if="showSurvey">
    <div class="page_jindu" v-if="surveyData.surveyTheme && surveyData.surveyTheme.openProgress">
      <div v-for="(j,i) in totalPage" :key="i" :style="i<currentPage ? {'backgroundColor': surveyData.surveyTheme.progressColor} : {}" class="jindu"></div>
    </div>
    <div class="box_header" v-if="surveyData.surveyInfo && currentPage == 1">
      <div class="title" :style="{'color':surveyData.surveyTheme.titleColor}" v-if="surveyData.surveyTheme.openTitle">{{surveyData.surveyInfo.surveyName}}</div>
      <div class="desc" :style="{'color':surveyData.surveyTheme.welcomeColor}" v-if="surveyData.surveyTheme.openWelcome" v-html="surveyData.surveyInfo.welcomeText"></div>
    </div>
    <div class="question_con">
      <div v-for="(item,index) in questionList" :key="index" class="question">
        <!-- 选择题 -->
        <div v-if="item.qesType == 'select'" class="select_question">
          <!-- 单选题 -->
          <radioQuestion v-if="item.otherType == 'radio' && item.display == true" :data="item" v-on:sendAnswer="sendAnswer" :currentPage="currentPage" :index="index" :color="surveyData.surveyTheme.optionColor" :fontSize="surveyData.surveyTheme.fontSize"></radioQuestion>
          <!-- 多选题 -->
          <multiQuestion v-if="item.otherType == 'multi' && item.display == true" :data="item" v-on:sendAnswer="sendAnswer" :currentPage="currentPage" :index="index" :color="surveyData.surveyTheme.optionColor" :fontSize="surveyData.surveyTheme.fontSize"></multiQuestion>
          <!-- 下拉题 -->
          <downQuestion v-if="item.otherType == 'down' && item.display == true" :data="item" v-on:sendAnswer="sendAnswer" :currentPage="currentPage" :index="index" :color="surveyData.surveyTheme.optionColor" :fontSize="surveyData.surveyTheme.fontSize"></downQuestion>
        </div>
        <!-- 文本题 -->
        <div v-if="item.qesType == 'text'" class="text_question">
          <!-- 单行文本题 -->
          <singleTextQuestion v-if="item.otherType == 'singleText' && item.display == true" :data="item" v-on:sendAnswer="sendAnswer" :currentPage="currentPage" :index="index"></singleTextQuestion>
          <!-- 多行文本题 -->
          <multiTextQuestion v-if="item.otherType == 'multiText' && item.display == true" :data="item" v-on:sendAnswer="sendAnswer" :currentPage="currentPage" :index="index"></multiTextQuestion>
          <!-- 多项短文本题 -->
          <multitermTextQuestion v-if="item.otherType == 'multitermText' && item.display == true" :data="item" v-on:sendAnswer="sendAnswer" :currentPage="currentPage" :index="index"></multitermTextQuestion>
        </div>
      </div>
      <!-- 底部按钮 -->
      <div class="bottom_navs">
        <van-button v-if="currentPage > 1" @click="prePage" block>上一页</van-button>
        <van-button v-if="currentPage < totalPage" @click="nextPage" :loading="btnLoading" :style="currentPage > 1 ? {'marginLeft':'20px'} : {}" :color="surveyData.surveyTheme.perTheme == 0 ? surveyData.surveyTheme.progressColor : surveyData.surveyTheme.buttonColor" block>下一页</van-button>
        <van-button v-if="currentPage == totalPage" @click="submit" :loading="btnLoading" :style="totalPage > 1 ? {'marginLeft':'20px'} : {}" :color="surveyData.surveyTheme.perTheme == 0 ? surveyData.surveyTheme.progressColor : surveyData.surveyTheme.buttonColor" block>提交</van-button>
      </div>
      <!-- 底部LOGO -->
      <div v-if="surveyData.surveyTheme.openLogo" class="bottom_logo">
        <img class="logo_img" src="../../assets/images/survey/technical_support_logo.png" alt="">
        <span class="logo_txt">由卓闻提供技术支持</span>
      </div>
    </div>
  </div>
  <!-- 开始答卷页面 -->
  <div class="start_answer" v-if="showStart">
    <div class="inner">
      <div class="tips_box">
        <div class="tips_tit">
          <span class="text">我承诺</span>
          <img src="@/assets/images/survey/note_icon.png" alt="" class="notes_icon">
        </div>
        <div class="tips_txt">本次调查的一切数据资料将会严格保密 确保不会外传</div>
      </div>
      <div class="bottom_box">
        <div class="rule_box">
          <div class="time_box">
            <img src="@/assets/images/survey/time_icon.png" alt="" class="time_icon">
            <span class="txt">预计答题时长：{{surveyConfig.answerTime == 0 ? '不限时长' : surveyConfig.answerTime+'分钟'}}</span>
            <!-- <span v-if="surveyConfig.answerTime" class="danger_txt">（中途退出包含在内）</span> -->
          </div>
          <div class="money_box">
            <img src="@/assets/images/survey/money_icon.png" alt="" class="money_icon">
            <span class="txt">
              最高奖励：{{surveyConfig.maxAward}}元
              <i v-if="surveyConfig.maxIntegral">+ {{surveyConfig.maxIntegral}}积分</i>
            </span>
          </div>
        </div>
        <div class="notice_box">
          <div class="tit">注意： </div>
          <div class="txt">问卷内设置检测题，若答案异常，答题机会将会被作废，请认真答题</div>
        </div>
      </div>
      <div class="start_btn" @click="startAnswer">开始答卷</div>
    </div>
  </div>
  <!-- 答题时间到弹窗 -->
  <div class="end_pop" v-if="showTimeEnd">
    <div class="inner">
      <div class="tit">答题时间到</div>
      <div class="txt first">很遗憾</div>
      <div class="txt">您未在规定时间内完成答卷</div>
      <div class="txt">本次问卷已失效</div>
      <div class="back_btn" @click="backToList">返回列表</div>
    </div>
  </div>
</div>
</template>
<script>
// 选择题
import radioQuestion from '@/components/selectQuestion/radioQuestion'
import multiQuestion from '@/components/selectQuestion/multiQuestion'
import downQuestion from '@/components/selectQuestion/downQuestion'
// 文本题
import singleTextQuestion from '@/components/textQuestion/singleTextQuestion'
import multiTextQuestion from '@/components/textQuestion/multiTextQuestion'
import multitermTextQuestion from '@/components/textQuestion/multitermTextQuestion'


export default {
  data () {
    return {
      userId:'',                            // 用户ID
      token:'',                             // token
      surveyId:'',                          // 问卷ID
      surveyShare:false,                    // 是否能被分享
      surveyData:{},                        // 问卷详情
      surveyConfig:{},                      // 问卷设置
      questionList:[],                      // 问卷显示的问题列表
      questions:[],                         // 所有问题分段
      totalPage:'',                         // 总分页数
      currentPage:1,                        // 当前分页
      selected:[],                          // 已选择的答案数据(提交下一页用)
      latitude:'',                          // 纬度
      longitude:'',                         // 经度
      btnLoading:false,                     // 按钮加载中
      showStart:false,                      // 是否展示开始答题页面
      showSurvey:false,                     // 是否展示问卷页面
      showTimeEnd:false,                    // 是否显示时间到弹窗
      hasTextLoadQesRules:[],               // 有文本加载的题的规则集合
      allQes:[],                            // 所有的问题
      code:'',                              // 链接上加密参数
      logicRuleList:[],                     // 逻辑规则列表
      historyStep:[],                        // 翻页步数堆栈记录
      forceQuit:false,                      // 是否是强制退出
    }
  },
  components: {
    radioQuestion,
    multiQuestion,
    downQuestion,
    singleTextQuestion,
    multiTextQuestion,
    multitermTextQuestion
  },
  created () {
    if(this.$route.query.encryption == 0){
      this.surveyId = this.$route.query.surveyId;
      this.userId = this.$route.query.userId;
      this.token = this.$route.query.token;
    }else{
      this.code = this.$route.query.code;
      console.log('链接上的code:',this.code);
      let str = window.atob(this.code);
      str = str.slice(3);
      str = str.substring(0,str.length-3)
      let params = window.atob(str);
      params = params.split(",");
      console.log('解密后的参数：',params);
      this.surveyId = params[0];
      this.userId = params[1];
      this.surveyShare = params[2];
      this.latitude = params[3] ? params[3] : '0';
      this.longitude = params[4] ? params[4] : '0';
      this.token = this.$route.query.token;
    }
    this.forceQuit = false;
    // 获取问卷配置
    this.getConfig()
  },
  mounted () {
  },
  computed:{
  },
  methods: {
    // 校验问卷
    checkSurvey(){
      let postData = {
        userId:this.userId,
        surveyId:this.surveyId
      }
      this.$http.post('/survey/appSurvey/checkSurvey',postData,false,this.token).then(res=>{
        console.log('校验问卷:',res);
        if(res.code == 200){
          switch(res.data){
            case -1:             // 未回答
              this.showStart = true;
            break;

            case 0:              // 答题中
              // 获取问卷详情
              this.getSurveyDetail();
            break;
          }
        }else{
          switch(res.code){
            case 10005:              // 停用
              this.$router.push({
                path:'/statusPage',
                query:{
                  status:res.code
                }
              })
            break;
            case 10013:              // 中断结束
              this.$router.push({
                path:'/statusPage',
                query:{
                  status:res.code,
                  messageText:this.surveyConfig.errorText
                }
              })
            break;
            case 10014:              // 完成
              this.$router.push({
                path:'/statusPage',
                query:{
                  status:res.code,
                  messageText:this.surveyConfig.endText
                }
              })
            break;
          }
        }
      })
    },
    // 获取问卷详情
    getSurveyDetail(){
      let postData = {
        userId:this.userId,
        surveyId:this.surveyId
      }
      this.$http.post('/survey/appSurvey/getSurveyPreview',postData,false,this.token).then(res=>{
        console.log('问卷详情:',res);
        if(res.code == 200){
          this.surveyData = res.data;
          // 所有问题数据列表(一维数组)
          res.data.questions.forEach((item,index)=>{
            this.$set(this.selected, index, [])
            item.forEach((im,idx)=>{
              this.allQes.push(im);
              this.selected[index].push({});
            })
          });
          // 文本加载规则列表
          this.hasTextLoadQesRules = res.data.hasTextLoadQesRules;
          console.log('allQes:',this.allQes);
          console.log('hasTextLoadQesRules:',this.hasTextLoadQesRules);
          // 带有分页的问题列表(二维数组)
          this.questions = res.data.questions;
          // 当前分页页数
          this.currentPage = res.data.surveySubmit.currentPage;
          // 获取历史翻页记录
          if(res.data.surveySubmit.historyStep){
            this.historyStep = res.data.surveySubmit.historyStep;
          }else{
            this.historyStep = [0];
          }
          // 总分页数
          this.totalPage = res.data.surveySubmit.totalPage;
          // 问卷第一页问题数据
          this.questionList = this.questions[this.currentPage-1];
          // 问卷已回答的答案数据(问卷回显用)
          if(res.data.surveySubmit.qusetionSubmit.length > 0){
            this.selected = res.data.surveySubmit.qusetionSubmit;
          }
          console.log('selected:',this.selected);
          // 问卷主题数据
          sessionStorage.setItem("surveyTheme",JSON.stringify(res.data.surveyTheme));
          // 显示问卷列表页面
          this.showSurvey = true;
          // 问卷倒计时
          // if(res.data.surveySubmit.estimatedEndTime){
          //   let timer = null;//定时器
          //   timer = setInterval(() => {
          //     let endTime = res.data.surveySubmit.estimatedEndTime.replace(/\-/g, "/"); 
          //     // let endTime = "2021-03-16 19:20:00".replace(/\-/g, "/"); 
          //     let leftTime = new Date(endTime) - new Date();//计算当前时间与活动结束时间的差值秒数
          //     if(leftTime <= 0){
          //       clearInterval(timer);
          //       this.showTimeEnd = true;
          //     }
          //   }, 1000);
          // }
          // 问卷逻辑规则列表
          res.data.logicConfigs.forEach(item=>{
            this.logicRuleList.push(JSON.parse(item.logicData));
          });
          console.log('logicRuleList:',this.logicRuleList);
          // 解析文本加载规则
          this.parseTextLoad();
        }
      })
    },
    // 获取问卷配置
    getConfig(){
      this.$http.post('/survey/surveyConfig/getSurveyConfig',{surveyId:this.surveyId},false,this.token).then(res=>{
        if(res.code == 200){
          this.surveyConfig = res.data;
          // 校验问卷
          this.checkSurvey();
        }
      })
    },
    // 开始答卷
    startAnswer(){
      let postData = {
        userId:this.userId,
        surveyId:this.surveyId,
        latitude:this.latitude ? this.latitude : '',
        longitude:this.longitude ? this.longitude :''
      }
      this.$http.post('/survey/appSurvey/confirmSurvey',postData,false,this.token).then(res=>{
        if(res.code == 200){
          this.showStart = false; 
          // 获取问卷详情
          this.getSurveyDetail();
        }
      })
    },
    // 接收子组件传来的答案
    sendAnswer(d){
      console.log('接收子组件的传值',d);
      // console.log(this.selected);
      this.selected[d.gIndex][d.qIndex] = d.submitQesObj;
      this.$forceUpdate();
      // console.log(this.selected);
      // 解析文本加载规则
      this.parseTextLoad();
    },
    // 解析文本加载规则
    parseTextLoad(){
      // console.log(this.allQes,this.hasTextLoadQesRules);
      this.allQes.forEach(qes=>{
        this.hasTextLoadQesRules.forEach((item,idx)=>{
          if(qes.qesNum == item.rule[0]){
            switch(item.rule[1]){
              case '1':
                // 题干
                if(item.subIndex == -1){
                  let qesName = this.questions[item.gindex][item.qindex].qesName;
                  this.surveyData.questions[item.gindex][item.qindex].qesName = qesName.replace(item.replaceStr,qes.qesName);
                  item.replaceStr = qes.qesName;
                  // console.log(item,this.questions[item.gindex][item.qindex].qesName);
                }else{
                  let subQesName = this.questions[item.gindex][item.qindex].subQes[item.subIndex].qesName;
                  this.surveyData.questions[item.gindex][item.qindex].subQes[item.subIndex].qesName = subQesName.replace(item.replaceStr,qes.qesName);
                  item.replaceStr = qes.qesName;
                }
              break;
              case '2':
                // 选项
                if(qes.answers){
                  // 无subQes时
                  qes.answers.forEach(ans=>{
                    if(ans.ansId == item.rule[2]){
                      if(item.subIndex == -1){
                        let qesName = this.questions[item.gindex][item.qindex].qesName;
                        this.surveyData.questions[item.gindex][item.qindex].qesName = qesName.replace(item.replaceStr,ans.ansName);
                        item.replaceStr = ans.ansName;
                      }else{
                        let subQesName = this.questions[item.gindex][item.qindex].subQes[item.subIndex].qesName;
                        this.surveyData.questions[item.gindex][item.qindex].subQes[item.subIndex].qesName = subQesName.replace(item.replaceStr,ans.ansName);
                        item.replaceStr = ans.ansName;
                      }
                    }
                  })
                }else{
                  // 有subQes时
                  qes.subQes.forEach(subQesItem=>{
                    if(subQesItem.qesId == item.rule[2]){
                      if(item.subIndex == -1){
                        let qesName = this.questions[item.gindex][item.qindex].qesName;
                        switch(item.rule[3]){
                          case 'Description':
                            this.surveyData.questions[item.gindex][item.qindex].qesName = qesName.replace(item.replaceStr,subQesItem.qesName);
                            item.replaceStr = subQesItem.qesName;
                          break;
                          case 'EntryValue':
                            if(subQesItem.ansContent){
                              this.surveyData.questions[item.gIndex][item.qIndex].qesName = qesName.replace(item.replaceStr,subQesItem.ansContent);
                              item.replaceStr = subQesItem.ansContent;
                            }
                          break;
                        }
                      }else{
                        let subQesName = this.questions[item.gindex][item.qindex].subQes[item.subIndex].qesName;
                        switch(item.rule[3]){
                          case 'Description':
                            this.surveyData.questions[item.gindex][item.qindex].subQes[item.subIndex].qesName = subQesName.replace(item.replaceStr,subQesItem.qesName);
                            item.replaceStr = subQesItem.qesName;
                          break;
                          case 'EntryValue':
                            if(subQesItem.ansContent){
                              this.surveyData.questions[item.gindex][item.qindex].subQes[item.subIndex].qesName = subQesName.replace(item.replaceStr,subQesItem.ansContent);
                              item.replaceStr = subQesItem.ansContent;
                              // console.log('subQesName:',this.surveyData.questions[item.gindex][item.qindex].subQes[item.subIndex].qesName,'ansContent:',subQesItem.ansContent,item.replaceStr);
                            }
                          break;
                        }
                      }
                    }
                  })
                }
              break;
              case '3':
                // 被选择的选项
                qes.answers.forEach(ans=>{
                  if(ans.ansId == qes.showSelected){
                    if(item.subIndex == -1){
                      let qesName = this.surveyData.questions[item.gindex][item.qindex].qesName;
                      this.surveyData.questions[item.gindex][item.qindex].qesName = qesName.replace(item.replaceStr,ans.ansName);
                      item.replaceStr = ans.ansName;
                    }else{
                      let qesName = this.surveyData.questions[item.gindex][item.qindex].subQes[item.subIndex].qesName;
                      // this.surveyData.questions[item.gindex][item.qindex].subQes[item.subIndex].qesName = qesName.replace(item.replaceStr,ans.ansName);
                      this.$set(this.surveyData.questions[item.gindex][item.qindex].subQes[item.subIndex],'qesName',qesName.replace(item.replaceStr,ans.ansName));
                      item.replaceStr = ans.ansName;
                    }
                  }
                })
              break;
              case '4':
                // 未选择的选项
                let str = '';
                qes.answers.forEach((ans,ansIndx)=>{
                  if(ans.ansId != qes.showSelected){
                    str+= ans.ansName + (ansIndx+1 == qes.answers.length ? '' :'，')
                  }
                })
                if(item.subIndex == -1){
                  let qesName = this.surveyData.questions[item.gindex][item.qindex].qesName;
                  this.surveyData.questions[item.gindex][item.qindex].qesName = qesName.replace(item.replaceStr,str);
                  item.replaceStr = str;
                }else{
                  let qesName = this.surveyData.questions[item.gindex][item.qindex].subQes[item.subIndex].qesName;
                  // console.log('else..',qesName);
                  this.surveyData.questions[item.gindex][item.qindex].subQes[item.subIndex].qesName = qesName.replace(item.replaceStr,str);
                  // this.$set(this.surveyData.questions[item.gindex][item.qindex].subQes[item.subIndex],'qesName',qesName.replace(item.replaceStr,str));
                  // console.log(item.replaceStr);
                  item.replaceStr = str;
                  // console.log(str);
                  // console.log(this.surveyData.questions[item.gindex][item.qindex].subQes[item.subIndex].qesName);
                  // console.log(item.gindex,item.qindex,item.subIndex);
                }
              break;
              case '5':
                // 所有的选项
                let strs = '';
                if(qes.answers){
                  // 无subQes时
                  qes.answers.forEach((ans,ansIndx)=>{
                    strs+= ans.ansName + (ansIndx+1 == qes.answers.length ? '' :'，')
                  })
                }else{
                  // 有subQes时
                  qes.subQes.forEach((subQesItem,subQesIndex)=>{
                    switch(item.rule[2]){
                      case 'Description':
                        strs+= subQesItem.qesName + (subQesIndex+1 == qes.subQes.length ? '' :'，')
                      break;
                      case 'EntryValue':
                        strs+= subQesItem.ansContent + ((subQesIndex+1 == qes.subQes.length || !subQesItem.ansContent) ? '' :'，')
                      break;
                    }
                  })
                }
                // console.log('======',strs);
                if(item.subIndex == -1){
                  let qesName = this.surveyData.questions[item.gindex][item.qindex].qesName;
                  if(strs.indexOf('null') == -1){
                    this.surveyData.questions[item.gindex][item.qindex].qesName = qesName.replace(item.replaceStr,strs);
                    item.replaceStr = strs;
                  }
                }else{
                  let qesName = this.surveyData.questions[item.gindex][item.qindex].subQes[item.subIndex].qesName;
                  if(strs.indexOf('null') == -1){
                    this.surveyData.questions[item.gindex][item.qindex].subQes[item.subIndex].qesName = qesName.replace(item.replaceStr,strs);
                    item.replaceStr = strs;
                  }
                }
              break;
              case '6':
                let value = qes.showSelected ? qes.showSelected : '';
                // 答题值
                if(item.subIndex == -1){
                  let qesName = this.questions[item.gindex][item.qindex].qesName;
                  if(value){
                    this.questions[item.gindex][item.qindex].qesName = qesName.replace(item.replaceStr,value);
                    item.replaceStr = value;
                  }
                }else{
                  let qesName = this.questions[item.gindex][item.qindex].subQes[item.subIndex].qesName;
                  if(value){
                    this.questions[item.gindex][item.qindex].subQes[item.subIndex].qesName = qesName.replace(item.replaceStr,value);
                    item.replaceStr = value;
                  }
                }
              break;
            }
          }
        })
      })
    },
    // 解析逻辑规则
    parseLogic(){
      this.allQes.forEach((qes,qesIdx)=>{
        this.logicRuleList.forEach(logic=>{
          if(logic.source.sourceQesId == qes.qesId){
            if(logic.action.type == "QUESTION_REDIRECTION"){
              logic.groups.forEach((group,gidx)=>{
                // 获取条件问题对象
                let qesObj = this.getQesObjByQesId(group.data.qesId);
                switch(group.data.prop.type){
                  case "OPTION":
                    switch(group.data.operator){
                      // 选项被选择
                      case "select":
                        // 只解析有答案的逻辑
                        if(qesObj.showSelected){
                          // 如果是多选题
                          if(String(qesObj.showSelected).indexOf("[") != -1){
                            let isMultiSelect = false;
                            JSON.parse(qesObj.showSelected).forEach(s=>{
                              if(s == group.data.prop.value){
                                isMultiSelect = true;
                                return;
                              }
                            })
                            //条件选项被选中
                            if(isMultiSelect){ 
                              //判断是否为父条件(父条件值为null)
                              if(group.operator){
                                //区分or与and逻辑比较
                                switch(group.operator){
                                  case "or":
                                    //子条件与父条件用||比对
                                    logic.result = logic.result || true; 
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && true; 
                                  break;
                                }
                              }else{
                                //父条件成立并赋值
                                logic.result = true; 
                              }
                            }else{ //条件选项未被选中
                              if(group.operator){
                                switch(group.operator){
                                  case "or":
                                    logic.result = logic.result || false;
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && false; 
                                  break;
                                }
                              }else{
                                logic.result = false;
                              }
                            }
                          }else{// 否则是单选题
                            //条件选项被选中
                            if(qesObj.showSelected == group.data.prop.value){
                              console.log('1...........被选中的答案,',qesObj.showSelected,'.......逻辑里面的条件',group.data.prop.value,'当前逻辑对象：',logic); 
                              //判断是否为父条件(父条件值为null)
                              if(group.operator){
                                //区分or与and逻辑比较
                                switch(group.operator){
                                  case "or":
                                    //子条件与父条件用||比对
                                    logic.result = logic.result || true; 
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && true; 
                                  break;
                                }
                              }else{
                                //父条件成立并赋值
                                logic.result = true; 
                              }
                            }else{ //条件选项未被选中 
                              if(group.operator){
                                switch(group.operator){
                                  case "or":
                                    logic.result = logic.result || false;
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && false; 
                                  break;
                                }
                              }else{
                                logic.result = false;
                              }
                            }
                          }
                          console.log('最终比对结果',logic.result,'gidx:',gidx,'logic.groups.length-1',logic.groups.length-1);
                          // 如果比较完成后条件成立
                          if(gidx == logic.groups.length-1 && logic.result){
                            //目标题ID不为0,0为结束
                            if(logic.action.targetQesId){
                              //循环把满足条件的题目隐藏
                              for(let i = qesIdx+1; i<this.allQes.length;i++){
                                if(this.allQes[i].qesId != logic.action.targetQesId){
                                  this.allQes[i].display = false;
                                }else{
                                  return;
                                }
                              }
                            }else{
                              //目标题ID为0,直接改为答题完成状态
                              this.quitSurvey();  
                            }
                          }
                        }
                      break;
                      // 选项未被选择
                      case "unselect":
                        // 只解析有答案的逻辑
                        if(qesObj.showSelected){
                          // 如果是多选题
                          if(String(qesObj.showSelected).indexOf("[") != -1){
                            let isMultiUnselect = true;
                            JSON.parse(qesObj.showSelected).forEach(s=>{
                              if(s == group.data.prop.value){
                                isMultiUnselect = false;
                                return;
                              }
                            })
                            //条件选项未被选中
                            if(isMultiUnselect){ 
                              //判断是否为父条件(父条件值为null)
                              if(group.operator){
                                //区分or与and逻辑比较
                                switch(group.operator){
                                  case "or":
                                    //子条件与父条件用||比对
                                    logic.result = logic.result || true; 
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && true; 
                                  break;
                                }
                              }else{
                                //父条件成立并赋值
                                logic.result = true; 
                              }
                            }else{ //条件选项被选中
                              if(group.operator){
                                switch(group.operator){
                                  case "or":
                                    logic.result = logic.result || false;
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && false; 
                                  break;
                                }
                              }else{
                                logic.result = false;
                              }
                            }
                          }else{// 否则是单选题
                            //条件选项被选中
                            if(qesObj.showSelected != group.data.prop.value){ 
                              //判断是否为父条件(父条件值为null)
                              if(group.operator){
                                //区分or与and逻辑比较
                                switch(group.operator){
                                  case "or":
                                    //子条件与父条件用||比对
                                    logic.result = logic.result || true; 
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && true; 
                                  break;
                                }
                              }else{
                                //父条件成立并赋值
                                logic.result = true; 
                              }
                            }else{ //条件选项未被选中
                              if(group.operator){
                                switch(group.operator){
                                  case "or":
                                    logic.result = logic.result || false;
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && false; 
                                  break;
                                }
                              }else{
                                logic.result = false;
                              }
                            }
                          }
                          // 如果比较完成后条件成立
                          if(gidx == logic.groups.length-1 && logic.result){
                            //目标题ID不为0,0为结束
                            if(logic.action.targetQesId){
                              //循环把满足条件的题目隐藏
                              for(let i = qesIdx+1; i<this.allQes.length;i++){
                                if(this.allQes[i].qesId != logic.action.targetQesId){
                                  this.allQes[i].display = false;
                                }else{
                                  return;
                                }
                              }
                            }else{
                              //目标题ID为0,直接改为答题完成状态
                              this.quitSurvey();  
                            }
                          }
                        }
                      break;
                    }
                  break;
                  case "RANGE":
                    switch(group.data.prop.value){
                      // 范围->所有
                      case "all":
                        switch(group.data.operator){
                          // 所有选项输入的值大于
                          case "gt":
                            let allGt = true;
                            qesObj.subQes.forEach(sub=>{
                              // 是否满足所有答案大于目标值
                              if(Number(sub.ansContent) <= Number(group.data.extra)){
                                allGt = false;
                                return;
                              }
                            })
                            //条件满足
                            if(allGt){ 
                              //判断是否为父条件(父条件值为null)
                              if(group.operator){
                                //区分or与and逻辑比较
                                switch(group.operator){
                                  case "or":
                                    //子条件与父条件用||比对
                                    logic.result = logic.result || true; 
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && true; 
                                  break;
                                }
                              }else{
                                //父条件成立并赋值
                                logic.result = true; 
                              }
                            }else{ //条件不满足
                              if(group.operator){
                                switch(group.operator){
                                  case "or":
                                    logic.result = logic.result || false;
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && false; 
                                  break;
                                }
                              }else{
                                logic.result = false;
                              }
                            }
                            // 如果比较完成后条件成立
                            if(gidx == logic.groups.length-1 && logic.result){
                              //目标题ID不为0,0为结束
                              if(logic.action.targetQesId){
                                //循环把满足条件的题目隐藏
                                for(let i = qesIdx+1; i<this.allQes.length;i++){
                                  if(this.allQes[i].qesId != logic.action.targetQesId){
                                    this.allQes[i].display = false;
                                  }else{
                                    return;
                                  }
                                }
                              }else{
                                //目标题ID为0,直接改为答题完成状态
                                this.quitSurvey();  
                              }
                            }
                          break;
                          // 所有选项输入的值等于
                          case "eq":
                            let allEq = true;
                            qesObj.subQes.forEach(sub=>{
                              // 是否满足所有答案等于目标值
                              if(Number(sub.ansContent) != Number(group.data.extra)){
                                allEq = false;
                                return;
                              }
                            })
                            //条件满足
                            if(allEq){ 
                              //判断是否为父条件(父条件值为null)
                              if(group.operator){
                                //区分or与and逻辑比较
                                switch(group.operator){
                                  case "or":
                                    //子条件与父条件用||比对
                                    logic.result = logic.result || true; 
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && true; 
                                  break;
                                }
                              }else{
                                //父条件成立并赋值
                                logic.result = true; 
                              }
                            }else{ //条件不满足
                              if(group.operator){
                                switch(group.operator){
                                  case "or":
                                    logic.result = logic.result || false;
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && false; 
                                  break;
                                }
                              }else{
                                logic.result = false;
                              }
                            }
                            // 如果比较完成后条件成立
                            if(gidx == logic.groups.length-1 && logic.result){
                              //目标题ID不为0,0为结束
                              if(logic.action.targetQesId){
                                //循环把满足条件的题目隐藏
                                for(let i = qesIdx+1; i<this.allQes.length;i++){
                                  if(this.allQes[i].qesId != logic.action.targetQesId){
                                    this.allQes[i].display = false;
                                  }else{
                                    return;
                                  }
                                }
                              }else{
                                //目标题ID为0,直接改为答题完成状态
                                this.quitSurvey();  
                              }
                            }
                          break;
                          // 所有选项输入的值小于
                          case "lt":
                            let allLt = true;
                            qesObj.subQes.forEach(sub=>{
                              console.log(Number(sub.ansContent));
                              // 是否满足所有答案小于目标值
                              if(Number(sub.ansContent) >= Number(group.data.extra) || Number(sub.ansContent) == 0){
                                allLt = false;
                                return;
                              }
                            })
                            //条件满足
                            if(allLt){ 
                              //判断是否为父条件(父条件值为null)
                              if(group.operator){
                                //区分or与and逻辑比较
                                switch(group.operator){
                                  case "or":
                                    //子条件与父条件用||比对
                                    logic.result = logic.result || true; 
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && true; 
                                  break;
                                }
                              }else{
                                //父条件成立并赋值
                                logic.result = true; 
                              }
                            }else{ //条件不满足
                              if(group.operator){
                                switch(group.operator){
                                  case "or":
                                    logic.result = logic.result || false;
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && false; 
                                  break;
                                }
                              }else{
                                logic.result = false;
                              }
                            }
                            // 如果比较完成后条件成立
                            if(gidx == logic.groups.length-1 && logic.result){
                              //目标题ID不为0,0为结束
                              if(logic.action.targetQesId){
                                //循环把满足条件的题目隐藏
                                for(let i = qesIdx+1; i<this.allQes.length;i++){
                                  if(this.allQes[i].qesId != logic.action.targetQesId){
                                    this.allQes[i].display = false;
                                  }else{
                                    return;
                                  }
                                }
                              }else{
                                //目标题ID为0,直接改为答题完成状态
                                this.quitSurvey();  
                              }
                            }
                          break;
                          // 所有选项被选择
                          case "select":
                            if(qesObj.showSelected){
                              let arr = JSON.parse(qesObj.showSelected);
                              //条件满足
                              if(arr.length == qesObj.answers.length){ 
                                //判断是否为父条件(父条件值为null)
                                if(group.operator){
                                  //区分or与and逻辑比较
                                  switch(group.operator){
                                    case "or":
                                      //子条件与父条件用||比对
                                      logic.result = logic.result || true; 
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && true; 
                                    break;
                                  }
                                }else{
                                  //父条件成立并赋值
                                  logic.result = true; 
                                }
                              }else{ //条件不满足
                                if(group.operator){
                                  switch(group.operator){
                                    case "or":
                                      logic.result = logic.result || false;
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && false; 
                                    break;
                                  }
                                }else{
                                  logic.result = false;
                                }
                              }
                              // 如果比较完成后条件成立
                              if(gidx == logic.groups.length-1 && logic.result){
                                //目标题ID不为0,0为结束
                                if(logic.action.targetQesId){
                                  //循环把满足条件的题目隐藏
                                  for(let i = qesIdx+1; i<this.allQes.length;i++){
                                    if(this.allQes[i].qesId != logic.action.targetQesId){
                                      this.allQes[i].display = false;
                                    }else{
                                      return;
                                    }
                                  }
                                }else{
                                  //目标题ID为0,直接改为答题完成状态
                                  this.quitSurvey();  
                                }
                              }
                            }
                          break;
                        }
                      break;
                      // 范围->任一
                      case "any":
                        switch(group.data.operator){
                          // 任一选项输入的值大于
                          case "gt":
                            let gt = false;
                            qesObj.subQes.forEach(sub=>{
                              // 是否满足任一答案大于目标值
                              if(Number(sub.ansContent) > Number(group.data.extra)){
                                gt = true;
                                return;
                              }
                            })
                            //条件满足
                            if(gt){ 
                              //判断是否为父条件(父条件值为null)
                              if(group.operator){
                                //区分or与and逻辑比较
                                switch(group.operator){
                                  case "or":
                                    //子条件与父条件用||比对
                                    logic.result = logic.result || true; 
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && true; 
                                  break;
                                }
                              }else{
                                //父条件成立并赋值
                                logic.result = true; 
                              }
                            }else{ //条件不满足
                              if(group.operator){
                                switch(group.operator){
                                  case "or":
                                    logic.result = logic.result || false;
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && false; 
                                  break;
                                }
                              }else{
                                logic.result = false;
                              }
                            }
                            // 如果比较完成后条件成立
                            if(gidx == logic.groups.length-1 && logic.result){
                              //目标题ID不为0,0为结束
                              if(logic.action.targetQesId){
                                //循环把满足条件的题目隐藏
                                for(let i = qesIdx+1; i<this.allQes.length;i++){
                                  if(this.allQes[i].qesId != logic.action.targetQesId){
                                    this.allQes[i].display = false;
                                  }else{
                                    return;
                                  }
                                }
                              }else{
                                //目标题ID为0,直接改为答题完成状态
                                this.quitSurvey();  
                              }
                            }
                          break;
                          // 任一选项输入的值等于
                          case "eq":
                            let eq = false;
                            qesObj.subQes.forEach(sub=>{
                              // 是否满足任一答案等于目标值
                              if(Number(sub.ansContent) == Number(group.data.extra)){
                                eq = true;
                                return;
                              }
                            })
                            //条件满足
                            if(eq){ 
                              //判断是否为父条件(父条件值为null)
                              if(group.operator){
                                //区分or与and逻辑比较
                                switch(group.operator){
                                  case "or":
                                    //子条件与父条件用||比对
                                    logic.result = logic.result || true; 
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && true; 
                                  break;
                                }
                              }else{
                                //父条件成立并赋值
                                logic.result = true; 
                              }
                            }else{ //条件不满足
                              if(group.operator){
                                switch(group.operator){
                                  case "or":
                                    logic.result = logic.result || false;
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && false; 
                                  break;
                                }
                              }else{
                                logic.result = false;
                              }
                            }
                            // 如果比较完成后条件成立
                            if(gidx == logic.groups.length-1 && logic.result){
                              //目标题ID不为0,0为结束
                              if(logic.action.targetQesId){
                                //循环把满足条件的题目隐藏
                                for(let i = qesIdx+1; i<this.allQes.length;i++){
                                  if(this.allQes[i].qesId != logic.action.targetQesId){
                                    this.allQes[i].display = false;
                                  }else{
                                    return;
                                  }
                                }
                              }else{
                                //目标题ID为0,直接改为答题完成状态
                                this.quitSurvey();  
                              }
                            }
                          break;
                          // 任一选项输入的值小于
                          case "lt":
                            let lt = false;
                            qesObj.subQes.forEach(sub=>{
                              // 是否满足任一答案小于目标值
                              if(Number(sub.ansContent) < Number(group.data.extra)){
                                lt = true;
                                return;
                              }
                            })
                            //条件满足
                            if(lt){ 
                              //判断是否为父条件(父条件值为null)
                              if(group.operator){
                                //区分or与and逻辑比较
                                switch(group.operator){
                                  case "or":
                                    //子条件与父条件用||比对
                                    logic.result = logic.result || true; 
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && true; 
                                  break;
                                }
                              }else{
                                //父条件成立并赋值
                                logic.result = true; 
                              }
                            }else{ //条件不满足
                              if(group.operator){
                                switch(group.operator){
                                  case "or":
                                    logic.result = logic.result || false;
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && false; 
                                  break;
                                }
                              }else{
                                logic.result = false;
                              }
                            }
                            // 如果比较完成后条件成立
                            if(gidx == logic.groups.length-1 && logic.result){
                              //目标题ID不为0,0为结束
                              if(logic.action.targetQesId){
                                //循环把满足条件的题目隐藏
                                for(let i = qesIdx+1; i<this.allQes.length;i++){
                                  if(this.allQes[i].qesId != logic.action.targetQesId){
                                    this.allQes[i].display = false;
                                  }else{
                                    return;
                                  }
                                }
                              }else{
                                //目标题ID为0,直接改为答题完成状态
                                this.quitSurvey();  
                              }
                            }
                          break;
                          // 任一选项被选择
                          case "select":
                            if(qesObj.showSelected){
                              let arr = JSON.parse(qesObj.showSelected);
                              //条件满足
                              if(arr.length > 0 && arr.length < qesObj.answers.length){ 
                                //判断是否为父条件(父条件值为null)
                                if(group.operator){
                                  //区分or与and逻辑比较
                                  switch(group.operator){
                                    case "or":
                                      //子条件与父条件用||比对
                                      logic.result = logic.result || true; 
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && true; 
                                    break;
                                  }
                                }else{
                                  //父条件成立并赋值
                                  logic.result = true; 
                                }
                              }else{ //条件不满足
                                if(group.operator){
                                  switch(group.operator){
                                    case "or":
                                      logic.result = logic.result || false;
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && false; 
                                    break;
                                  }
                                }else{
                                  logic.result = false;
                                }
                              }
                              console.log('log................',logic.result);
                              // 如果比较完成后条件成立
                              if(gidx == logic.groups.length-1 && logic.result){
                                console.log('log.............执行...');
                                //目标题ID不为0,0为结束
                                if(logic.action.targetQesId){
                                  //循环把满足条件的题目隐藏
                                  for(let i = qesIdx+1; i<this.allQes.length;i++){
                                    if(this.allQes[i].qesId != logic.action.targetQesId){
                                      this.allQes[i].display = false;
                                    }else{
                                      return;
                                    }
                                  }
                                }else{
                                  //目标题ID为0,直接改为答题完成状态
                                  this.quitSurvey();  
                                }
                              }
                            }
                          break;
                        }
                      break;
                    }
                  break;
                  case "SUM":
                    if(qesObj.showSelected){
                      let arr = JSON.parse(qesObj.showSelected)
                      switch(group.data.prop.value){
                        // 选中数
                        case "selectCount":
                          switch(group.data.operator){
                            // 选中数大于目标值
                            case "gt":
                              if(arr.length > Number(group.data.extra)){
                                //判断是否为父条件(父条件值为null)
                                if(group.operator){
                                  //区分or与and逻辑比较
                                  switch(group.operator){
                                    case "or":
                                      //子条件与父条件用||比对
                                      logic.result = logic.result || true; 
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && true; 
                                    break;
                                  }
                                }else{
                                  //父条件成立并赋值
                                  logic.result = true; 
                                }
                              }else{
                                //判断是否为父条件(父条件值为null)
                                if(group.operator){
                                  //区分or与and逻辑比较
                                  switch(group.operator){
                                    case "or":
                                      //子条件与父条件用||比对
                                      logic.result = logic.result || false; 
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && false; 
                                    break;
                                  }
                                }else{
                                  //父条件成立并赋值
                                  logic.result = false; 
                                }
                              }
                              // 如果比较完成后条件成立
                              if(gidx == logic.groups.length-1 && logic.result){
                                //目标题ID不为0,0为结束
                                if(logic.action.targetQesId){
                                  //循环把满足条件的题目隐藏
                                  for(let i = qesIdx+1; i<this.allQes.length;i++){
                                    if(this.allQes[i].qesId != logic.action.targetQesId){
                                      this.allQes[i].display = false;
                                    }else{
                                      return;
                                    }
                                  }
                                }else{
                                  //目标题ID为0,直接改为答题完成状态
                                  this.quitSurvey();  
                                }
                              }
                            break;
                            // 选中数等于目标值
                            case "eq":
                              if(arr.length == Number(group.data.extra)){
                                //判断是否为父条件(父条件值为null)
                                if(group.operator){
                                  //区分or与and逻辑比较
                                  switch(group.operator){
                                    case "or":
                                      //子条件与父条件用||比对
                                      logic.result = logic.result || true; 
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && true; 
                                    break;
                                  }
                                }else{
                                  //父条件成立并赋值
                                  logic.result = true; 
                                }
                              }else{
                                //判断是否为父条件(父条件值为null)
                                if(group.operator){
                                  //区分or与and逻辑比较
                                  switch(group.operator){
                                    case "or":
                                      //子条件与父条件用||比对
                                      logic.result = logic.result || false; 
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && false; 
                                    break;
                                  }
                                }else{
                                  //父条件成立并赋值
                                  logic.result = false; 
                                }
                              }
                              // 如果比较完成后条件成立
                              if(gidx == logic.groups.length-1 && logic.result){
                                //目标题ID不为0,0为结束
                                if(logic.action.targetQesId){
                                  //循环把满足条件的题目隐藏
                                  for(let i = qesIdx+1; i<this.allQes.length;i++){
                                    if(this.allQes[i].qesId != logic.action.targetQesId){
                                      this.allQes[i].display = false;
                                    }else{
                                      return;
                                    }
                                  }
                                }else{
                                  //目标题ID为0,直接改为答题完成状态
                                  this.quitSurvey();  
                                }
                              }
                            break;
                            // 选中数小于目标值
                            case "lt":
                              if(arr.length < Number(group.data.extra)){
                                //判断是否为父条件(父条件值为null)
                                if(group.operator){
                                  //区分or与and逻辑比较
                                  switch(group.operator){
                                    case "or":
                                      //子条件与父条件用||比对
                                      logic.result = logic.result || true; 
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && true; 
                                    break;
                                  }
                                }else{
                                  //父条件成立并赋值
                                  logic.result = true; 
                                }
                              }else{
                                //判断是否为父条件(父条件值为null)
                                if(group.operator){
                                  //区分or与and逻辑比较
                                  switch(group.operator){
                                    case "or":
                                      //子条件与父条件用||比对
                                      logic.result = logic.result || false; 
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && false; 
                                    break;
                                  }
                                }else{
                                  //父条件成立并赋值
                                  logic.result = false; 
                                }
                              }
                              // 如果比较完成后条件成立
                              if(gidx == logic.groups.length-1 && logic.result){
                                //目标题ID不为0,0为结束
                                if(logic.action.targetQesId){
                                  //循环把满足条件的题目隐藏
                                  for(let i = qesIdx+1; i<this.allQes.length;i++){
                                    if(this.allQes[i].qesId != logic.action.targetQesId){
                                      this.allQes[i].display = false;
                                    }else{
                                      return;
                                    }
                                  }
                                }else{
                                  //目标题ID为0,直接改为答题完成状态
                                  this.quitSurvey();  
                                }
                              }
                            break;
                          }
                        break;
                        // 未选中数
                        case "unselectCount":
                          let unCount = qesObj.answers.length - arr.length;
                          switch(group.data.operator){
                            // 未选中数大于目标值
                            case "gt":
                              if(unCount > Number(group.data.extra)){
                                //判断是否为父条件(父条件值为null)
                                if(group.operator){
                                  //区分or与and逻辑比较
                                  switch(group.operator){
                                    case "or":
                                      //子条件与父条件用||比对
                                      logic.result = logic.result || true; 
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && true; 
                                    break;
                                  }
                                }else{
                                  //父条件成立并赋值
                                  logic.result = true; 
                                }
                              }else{
                                //判断是否为父条件(父条件值为null)
                                if(group.operator){
                                  //区分or与and逻辑比较
                                  switch(group.operator){
                                    case "or":
                                      //子条件与父条件用||比对
                                      logic.result = logic.result || false; 
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && false; 
                                    break;
                                  }
                                }else{
                                  //父条件成立并赋值
                                  logic.result = false; 
                                }
                              }
                              // 如果比较完成后条件成立
                              if(gidx == logic.groups.length-1 && logic.result){
                                //目标题ID不为0,0为结束
                                if(logic.action.targetQesId){
                                  //循环把满足条件的题目隐藏
                                  for(let i = qesIdx+1; i<this.allQes.length;i++){
                                    if(this.allQes[i].qesId != logic.action.targetQesId){
                                      this.allQes[i].display = false;
                                    }else{
                                      return;
                                    }
                                  }
                                }else{
                                  //目标题ID为0,直接改为答题完成状态
                                  this.quitSurvey();  
                                }
                              }
                            break;
                            // 未选中数等于目标值
                            case "eq":
                              if(unCount == Number(group.data.extra)){
                                //判断是否为父条件(父条件值为null)
                                if(group.operator){
                                  //区分or与and逻辑比较
                                  switch(group.operator){
                                    case "or":
                                      //子条件与父条件用||比对
                                      logic.result = logic.result || true; 
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && true; 
                                    break;
                                  }
                                }else{
                                  //父条件成立并赋值
                                  logic.result = true; 
                                }
                              }else{
                                //判断是否为父条件(父条件值为null)
                                if(group.operator){
                                  //区分or与and逻辑比较
                                  switch(group.operator){
                                    case "or":
                                      //子条件与父条件用||比对
                                      logic.result = logic.result || false; 
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && false; 
                                    break;
                                  }
                                }else{
                                  //父条件成立并赋值
                                  logic.result = false; 
                                }
                              }
                              // 如果比较完成后条件成立
                              if(gidx == logic.groups.length-1 && logic.result){
                                //目标题ID不为0,0为结束
                                if(logic.action.targetQesId){
                                  //循环把满足条件的题目隐藏
                                  for(let i = qesIdx+1; i<this.allQes.length;i++){
                                    if(this.allQes[i].qesId != logic.action.targetQesId){
                                      this.allQes[i].display = false;
                                    }else{
                                      return;
                                    }
                                  }
                                }else{
                                  //目标题ID为0,直接改为答题完成状态
                                  this.quitSurvey();  
                                }
                              }
                            break;
                            // 未选中数小于目标值
                            case "lt":
                              if(unCount < Number(group.data.extra)){
                                //判断是否为父条件(父条件值为null)
                                if(group.operator){
                                  //区分or与and逻辑比较
                                  switch(group.operator){
                                    case "or":
                                      //子条件与父条件用||比对
                                      logic.result = logic.result || true; 
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && true; 
                                    break;
                                  }
                                }else{
                                  //父条件成立并赋值
                                  logic.result = true; 
                                }
                              }else{
                                //判断是否为父条件(父条件值为null)
                                if(group.operator){
                                  //区分or与and逻辑比较
                                  switch(group.operator){
                                    case "or":
                                      //子条件与父条件用||比对
                                      logic.result = logic.result || false; 
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && false; 
                                    break;
                                  }
                                }else{
                                  //父条件成立并赋值
                                  logic.result = false; 
                                }
                              }
                              // 如果比较完成后条件成立
                              if(gidx == logic.groups.length-1 && logic.result){
                                //目标题ID不为0,0为结束
                                if(logic.action.targetQesId){
                                  //循环把满足条件的题目隐藏
                                  for(let i = qesIdx+1; i<this.allQes.length;i++){
                                    if(this.allQes[i].qesId != logic.action.targetQesId){
                                      this.allQes[i].display = false;
                                    }else{
                                      return;
                                    }
                                  }
                                }else{
                                  //目标题ID为0,直接改为答题完成状态
                                  this.quitSurvey();  
                                }
                              }
                            break;
                          }
                        break;
                      }
                    }
                  break;
                  case "VALUE":
                    if(qesObj.showSelected){
                      switch(group.data.operator){
                        // 输入的值大于目标值
                        case "gt":
                          //条件满足
                          if(Number(qesObj.showSelected) > Number(group.data.extra)){ 
                            //判断是否为父条件(父条件值为null)
                            if(group.operator){
                              //区分or与and逻辑比较
                              switch(group.operator){
                                case "or":
                                  //子条件与父条件用||比对
                                  logic.result = logic.result || true; 
                                break;
                                case "and":
                                  //子条件与父条件用&&比对
                                  logic.result = logic.result && true; 
                                break;
                              }
                            }else{
                              //父条件成立并赋值
                              logic.result = true; 
                            }
                          }else{ //条件不满足
                            if(group.operator){
                              switch(group.operator){
                                case "or":
                                  logic.result = logic.result || false;
                                break;
                                case "and":
                                  //子条件与父条件用&&比对
                                  logic.result = logic.result && false; 
                                break;
                              }
                            }else{
                              logic.result = false;
                            }
                          }
                          // 如果比较完成后条件成立
                          if(gidx == logic.groups.length-1 && logic.result){
                            //目标题ID不为0,0为结束
                            if(logic.action.targetQesId){
                              //循环把满足条件的题目隐藏
                              for(let i = qesIdx+1; i<this.allQes.length;i++){
                                if(this.allQes[i].qesId != logic.action.targetQesId){
                                  this.allQes[i].display = false;
                                }else{
                                  return;
                                }
                              }
                            }else{
                              //目标题ID为0,直接改为答题完成状态
                              this.quitSurvey();  
                            }
                          }
                        break;
                        // 输入的值等于目标值
                        case "eq":
                          //条件满足
                          if(Number(qesObj.showSelected) == Number(group.data.extra)){ 
                            //判断是否为父条件(父条件值为null)
                            if(group.operator){
                              //区分or与and逻辑比较
                              switch(group.operator){
                                case "or":
                                  //子条件与父条件用||比对
                                  logic.result = logic.result || true; 
                                break;
                                case "and":
                                  //子条件与父条件用&&比对
                                  logic.result = logic.result && true; 
                                break;
                              }
                            }else{
                              //父条件成立并赋值
                              logic.result = true; 
                            }
                          }else{ //条件不满足
                            if(group.operator){
                              switch(group.operator){
                                case "or":
                                  logic.result = logic.result || false;
                                break;
                                case "and":
                                  //子条件与父条件用&&比对
                                  logic.result = logic.result && false; 
                                break;
                              }
                            }else{
                              logic.result = false;
                            }
                          }
                          // 如果比较完成后条件成立
                          if(gidx == logic.groups.length-1 && logic.result){
                            //目标题ID不为0,0为结束
                            if(logic.action.targetQesId){
                              //循环把满足条件的题目隐藏
                              for(let i = qesIdx+1; i<this.allQes.length;i++){
                                if(this.allQes[i].qesId != logic.action.targetQesId){
                                  this.allQes[i].display = false;
                                }else{
                                  return;
                                }
                              }
                            }else{
                              //目标题ID为0,直接改为答题完成状态
                              this.quitSurvey();  
                            }
                          }
                        break;
                        // 输入的值小于目标值
                        case "lt":
                          //条件满足
                          if(Number(qesObj.showSelected) < Number(group.data.extra)){ 
                            //判断是否为父条件(父条件值为null)
                            if(group.operator){
                              //区分or与and逻辑比较
                              switch(group.operator){
                                case "or":
                                  //子条件与父条件用||比对
                                  logic.result = logic.result || true; 
                                break;
                                case "and":
                                  //子条件与父条件用&&比对
                                  logic.result = logic.result && true; 
                                break;
                              }
                            }else{
                              //父条件成立并赋值
                              logic.result = true; 
                            }
                          }else{ //条件不满足
                            if(group.operator){
                              switch(group.operator){
                                case "or":
                                  logic.result = logic.result || false;
                                break;
                                case "and":
                                  //子条件与父条件用&&比对
                                  logic.result = logic.result && false; 
                                break;
                              }
                            }else{
                              logic.result = false;
                            }
                          }
                          // 如果比较完成后条件成立
                          if(gidx == logic.groups.length-1 && logic.result){
                            //目标题ID不为0,0为结束
                            if(logic.action.targetQesId){
                              //循环把满足条件的题目隐藏
                              for(let i = qesIdx+1; i<this.allQes.length;i++){
                                if(this.allQes[i].qesId != logic.action.targetQesId){
                                  this.allQes[i].display = false;
                                }else{
                                  return;
                                }
                              }
                            }else{
                              //目标题ID为0,直接改为答题完成状态
                              this.quitSurvey();  
                            }
                          }
                        break;
                      }
                    }
                  break;
                  case "VALUE_KEY":
                    switch(group.data.operator){
                      // 选项输入的值大于
                      case "gt":
                        qesObj.subQes.forEach(sub=>{
                          //当前题选项ID与规则选项ID匹配
                          if(sub.qesId == group.data.prop.value){    
                            // 填答有值的情况下进行解析
                            if(sub.ansContent){
                              //条件满足
                              if(sub.ansContent && Number(sub.ansContent) > Number(group.data.extra)){ 
                                //判断是否为父条件(父条件值为null)
                                if(group.operator){
                                  //区分or与and逻辑比较
                                  switch(group.operator){
                                    case "or":
                                      //子条件与父条件用||比对
                                      logic.result = logic.result || true; 
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && true; 
                                    break;
                                  }
                                }else{
                                  //父条件成立并赋值
                                  logic.result = true; 
                                }
                              }else{ //条件不满足
                                if(group.operator){
                                  switch(group.operator){
                                    case "or":
                                      logic.result = logic.result || false;
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && false; 
                                    break;
                                  }
                                }else{
                                  logic.result = false;
                                }
                              }
                              // 如果比较完成后条件成立
                              if(gidx == logic.groups.length-1 && logic.result){
                                //目标题ID不为0,0为结束
                                if(logic.action.targetQesId){
                                  //循环把满足条件的题目隐藏
                                  for(let i = qesIdx+1; i<this.allQes.length;i++){
                                    if(this.allQes[i].qesId != logic.action.targetQesId){
                                      this.allQes[i].display = false;
                                    }else{
                                      return;
                                    }
                                  }
                                }else{
                                  //目标题ID为0,直接改为答题完成状态
                                  this.quitSurvey();  
                                }
                              }
                            }                                                          
                          }
                        })
                      break;
                      // 选项输入的值等于
                      case "eq":
                        qesObj.subQes.forEach(sub=>{
                          //当前题选项ID与规则选项ID匹配
                          if(sub.qesId == group.data.prop.value){
                            // 填答有值的情况下进行解析
                            if(sub.ansContent){
                              //条件满足
                              if(sub.ansContent && Number(sub.ansContent) == Number(group.data.extra)){ 
                                //判断是否为父条件(父条件值为null)
                                if(group.operator){
                                  //区分or与and逻辑比较
                                  switch(group.operator){
                                    case "or":
                                      //子条件与父条件用||比对
                                      logic.result = logic.result || true; 
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && true; 
                                    break;
                                  }
                                }else{
                                  //父条件成立并赋值
                                  logic.result = true; 
                                }
                              }else{ //条件不满足
                                if(group.operator){
                                  switch(group.operator){
                                    case "or":
                                      logic.result = logic.result || false;
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && false; 
                                    break;
                                  }
                                }else{
                                  logic.result = false;
                                }
                              }
                              // 如果比较完成后条件成立
                              if(gidx == logic.groups.length-1 && logic.result){
                                //目标题ID不为0,0为结束
                                if(logic.action.targetQesId){
                                  //循环把满足条件的题目隐藏
                                  for(let i = qesIdx+1; i<this.allQes.length;i++){
                                    if(this.allQes[i].qesId != logic.action.targetQesId){
                                      this.allQes[i].display = false;
                                    }else{
                                      return;
                                    }
                                  }
                                }else{
                                  //目标题ID为0,直接改为答题完成状态
                                  this.quitSurvey();  
                                }
                              }
                            }                                                              
                          }
                        })
                      break;
                      // 选项输入的值小于
                      case "lt":
                        qesObj.subQes.forEach(sub=>{
                          if(sub.qesId == group.data.prop.value){
                            // 填答有值的情况下进行解析
                            if(sub.ansContent){
                              //条件满足
                              if(sub.ansContent && Number(sub.ansContent) < Number(group.data.extra)){ 
                                //判断是否为父条件(父条件值为null)
                                if(group.operator){
                                  //区分or与and逻辑比较
                                  switch(group.operator){
                                    case "or":
                                      //子条件与父条件用||比对
                                      logic.result = logic.result || true; 
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && true; 
                                    break;
                                  }
                                }else{
                                  //父条件成立并赋值
                                  logic.result = true; 
                                }
                              }else{ //条件不满足
                                if(group.operator){
                                  switch(group.operator){
                                    case "or":
                                      logic.result = logic.result || false;
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && false; 
                                    break;
                                  }
                                }else{
                                  logic.result = false;
                                }
                              }
                              // 如果比较完成后条件成立
                              if(gidx == logic.groups.length-1 && logic.result){
                                //目标题ID不为0,0为结束
                                if(logic.action.targetQesId){
                                  //循环把满足条件的题目隐藏
                                  for(let i = qesIdx+1; i<this.allQes.length;i++){
                                    if(this.allQes[i].qesId != logic.action.targetQesId){
                                      this.allQes[i].display = false;
                                    }else{
                                      return;
                                    }
                                  }
                                }else{
                                  //目标题ID为0,直接改为答题完成状态
                                  this.quitSurvey();  
                                }
                              }                                                              
                            }  
                          }
                        })
                      break;
                    }
                  break;
                }
              })
            }else if(logic.action.type == "QUESTION_SHOW"){
              logic.groups.forEach((group,gidx)=>{
                // 获取条件问题对象
                let qesObj = this.getQesObjByQesId(group.data.qesId);
                switch(group.data.prop.type){
                  case "OPTION":
                    switch(group.data.operator){
                      // 选项被选择
                      case "select":
                        // 只解析有答案的逻辑
                        // if(qesObj.showSelected){
                          // 如果是多选题
                          if(String(qesObj.showSelected).indexOf("[") != -1){
                            let isMultiSelect = false;
                            JSON.parse(qesObj.showSelected).forEach(s=>{
                              if(s == group.data.prop.value){
                                isMultiSelect = true;
                                return;
                              }
                            })
                            //条件选项被选中
                            if(qesObj.display && isMultiSelect){ 
                              //判断是否为父条件(父条件值为null)
                              if(group.operator){
                                //区分or与and逻辑比较
                                switch(group.operator){
                                  case "or":
                                    //子条件与父条件用||比对
                                    logic.result = logic.result || true; 
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && true; 
                                  break;
                                }
                              }else{
                                //父条件成立并赋值
                                logic.result = true; 
                              }
                            }else{ //条件选项未被选中
                              if(group.operator){
                                switch(group.operator){
                                  case "or":
                                    logic.result = logic.result || false;
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && false; 
                                  break;
                                }
                              }else{
                                logic.result = false;
                              }
                            }
                          }else{// 否则是单选题
                            //条件选项被选中
                            if(qesObj.display && qesObj.showSelected == group.data.prop.value){ 
                              console.log(qesObj.showSelected,'被选中',group.data.prop.value);
                              //判断是否为父条件(父条件值为null)
                              if(group.operator){
                                //区分or与and逻辑比较
                                switch(group.operator){
                                  case "or":
                                    //子条件与父条件用||比对
                                    logic.result = logic.result || true; 
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && true; 
                                  break;
                                }
                              }else{
                                //父条件成立并赋值
                                logic.result = true; 
                              }
                            }else{ //条件选项未被选中
                              console.log(qesObj.showSelected,'未被选中',group.data.prop.value);
                              if(group.operator){
                                switch(group.operator){
                                  case "or":
                                    logic.result = logic.result || false;
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && false; 
                                  break;
                                }
                              }else{
                                logic.result = false;
                              }
                            }
                          }
                          console.log('执行隐藏条件',gidx,logic.groups.length-1,logic.result);
                          // 如果比较完成后条件成立
                          if(gidx == logic.groups.length-1 && logic.result == true){
                            //循环把满足条件的题目显示
                            for(let i = 0; i<this.allQes.length;i++){
                              if(this.allQes[i].qesId == logic.action.targetQesId){
                                console.log('问题被显示',this.allQes[i].qesId,logic.action.targetQesId,logic.source.sourceQesId);
                                this.allQes[i].display = true;
                                return;
                              }
                            }
                          }
                          // 如果比较完成后条件不成立
                          if(gidx == logic.groups.length-1 && logic.result == false){
                            //循环把满足条件的题目隐藏
                            for(let i = 0; i<this.allQes.length;i++){                          //循环把满足条件的题目隐藏
                              if(this.allQes[i].qesId == logic.action.targetQesId){
                                console.log('问题被隐藏',this.allQes[i].qesId,logic.action.targetQesId,logic.source.sourceQesId);
                                this.allQes[i].display = false;
                                return;
                              }
                            }
                          }
                        // }
                      break;
                      // 选项未被选择
                      case "unselect":
                        // 如果是多选题
                        if(String(qesObj.showSelected).indexOf("[") != -1){
                          let isMultiUnSelect = true;
                          JSON.parse(qesObj.showSelected).forEach(s=>{
                            if(s == group.data.prop.value){
                              isMultiUnSelect = false;
                              return;
                            }
                          })
                          //条件选项未被选中
                          if(qesObj.display && isMultiUnSelect){ 
                            //判断是否为父条件(父条件值为null)
                            if(group.operator){
                              //区分or与and逻辑比较
                              switch(group.operator){
                                case "or":
                                  //子条件与父条件用||比对
                                  logic.result = logic.result || true; 
                                break;
                                case "and":
                                  //子条件与父条件用&&比对
                                  logic.result = logic.result && true; 
                                break;
                              }
                            }else{
                              //父条件成立并赋值
                              logic.result = true; 
                            }
                          }else{ //条件选项被选中
                            if(group.operator){
                              switch(group.operator){
                                case "or":
                                  logic.result = logic.result || false;
                                break;
                                case "and":
                                  //子条件与父条件用&&比对
                                  logic.result = logic.result && false; 
                                break;
                              }
                            }else{
                              logic.result = false;
                            }
                          }
                        }else{// 否则是单选题
                          //条件选项被选中
                          if(qesObj.display && qesObj.showSelected != group.data.prop.value){ 
                            //判断是否为父条件(父条件值为null)
                            if(group.operator){
                              //区分or与and逻辑比较
                              switch(group.operator){
                                case "or":
                                  //子条件与父条件用||比对
                                  logic.result = logic.result || true; 
                                break;
                                case "and":
                                  //子条件与父条件用&&比对
                                  logic.result = logic.result && true; 
                                break;
                              }
                            }else{
                              //父条件成立并赋值
                              logic.result = true; 
                            }
                          }else{ //条件选项未被选中
                            if(group.operator){
                              switch(group.operator){
                                case "or":
                                  logic.result = logic.result || false;
                                break;
                                case "and":
                                  //子条件与父条件用&&比对
                                  logic.result = logic.result && false; 
                                break;
                              }
                            }else{
                              logic.result = false;
                            }
                          }
                        }
                        // 如果比较完成后条件成立
                        if(gidx == logic.groups.length-1 && logic.result == true){
                          //循环把满足条件的题目显示
                          for(let i = 0; i<this.allQes.length;i++){                       
                            if(this.allQes[i].qesId == logic.action.targetQesId){
                              this.allQes[i].display = true;
                              return;
                            }
                          }
                        }
                        // 如果比较完成后条件不成立
                        if(gidx == logic.groups.length-1 && logic.result == false){
                          //循环把满足条件的题目隐藏
                          for(let i = 0; i<this.allQes.length;i++){       
                            if(this.allQes[i].qesId == logic.action.targetQesId){
                              this.allQes[i].display = false;
                              return;
                            }
                          }
                        }
                      break;
                    }
                  break;
                  case "RANGE":
                    switch(group.data.prop.value){
                      // 范围->所有
                      case "all":
                        switch(group.data.operator){
                          // 所有选项输入的值大于
                          case "gt":
                            let allGt = true;
                            qesObj.subQes.forEach(sub=>{
                              // 是否满足所有答案大于目标值
                              if(Number(sub.ansContent) <= Number(group.data.extra)){
                                allGt = false;
                                return;
                              }
                            })
                            //条件满足
                            if(qesObj.display && allGt){ 
                              //判断是否为父条件(父条件值为null)
                              if(group.operator){
                                //区分or与and逻辑比较
                                switch(group.operator){
                                  case "or":
                                    //子条件与父条件用||比对
                                    logic.result = logic.result || true; 
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && true; 
                                  break;
                                }
                              }else{
                                //父条件成立并赋值
                                logic.result = true; 
                              }
                            }else{ //条件不满足
                              if(group.operator){
                                switch(group.operator){
                                  case "or":
                                    logic.result = logic.result || false;
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && false; 
                                  break;
                                }
                              }else{
                                logic.result = false;
                              }
                            }
                            // 如果比较完成后条件成立
                            if(gidx == logic.groups.length-1 && logic.result == true){
                              //循环把满足条件的题目显示
                              for(let i = 0; i<this.allQes.length;i++){            
                                if(this.allQes[i].qesId == logic.action.targetQesId){
                                  this.allQes[i].display = true;
                                  return;
                                }
                              }
                            }
                            // 如果比较完成后条件不成立
                            if(gidx == logic.groups.length-1 && logic.result == false){
                              //循环把满足条件的题目隐藏
                              for(let i = 0; i<this.allQes.length;i++){            
                                if(this.allQes[i].qesId == logic.action.targetQesId){
                                  this.allQes[i].display = false;
                                  return;
                                }
                              }
                            }
                          break;
                          // 所有选项输入的值等于
                          case "eq":
                            let allEq = true;
                            qesObj.subQes.forEach(sub=>{
                              // 是否满足所有答案大于目标值
                              if(Number(sub.ansContent) != Number(group.data.extra)){
                                allEq = false;
                                return;
                              }
                            })
                            //条件满足
                            if(qesObj.display && allEq){ 
                              //判断是否为父条件(父条件值为null)
                              if(group.operator){
                                //区分or与and逻辑比较
                                switch(group.operator){
                                  case "or":
                                    //子条件与父条件用||比对
                                    logic.result = logic.result || true; 
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && true; 
                                  break;
                                }
                              }else{
                                //父条件成立并赋值
                                logic.result = true; 
                              }
                            }else{ //条件不满足
                              if(group.operator){
                                switch(group.operator){
                                  case "or":
                                    logic.result = logic.result || false;
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && false; 
                                  break;
                                }
                              }else{
                                logic.result = false;
                              }
                            }
                            // 如果比较完成后条件成立
                            if(gidx == logic.groups.length-1 && logic.result == true){
                              //循环把满足条件的题目显示
                              for(let i = 0; i<this.allQes.length;i++){            
                                if(this.allQes[i].qesId == logic.action.targetQesId){
                                  this.allQes[i].display = true;
                                  return;
                                }
                              }
                            }
                            // 如果比较完成后条件不成立
                            if(gidx == logic.groups.length-1 && logic.result == false){
                              //循环把满足条件的题目隐藏
                              for(let i = 0; i<this.allQes.length;i++){            
                                if(this.allQes[i].qesId == logic.action.targetQesId){
                                  this.allQes[i].display = false;
                                  return;
                                }
                              }
                            }
                          break;
                          // 所有选项输入的值小于
                          case "lt":
                            let allLt = true;
                            qesObj.subQes.forEach(sub=>{
                              // 是否满足所有答案大于目标值
                              if(Number(sub.ansContent) >= Number(group.data.extra)){
                                allLt = false;
                                return;
                              }
                            })
                            //条件满足
                            if(qesObj.display && allLt){ 
                              //判断是否为父条件(父条件值为null)
                              if(group.operator){
                                //区分or与and逻辑比较
                                switch(group.operator){
                                  case "or":
                                    //子条件与父条件用||比对
                                    logic.result = logic.result || true; 
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && true; 
                                  break;
                                }
                              }else{
                                //父条件成立并赋值
                                logic.result = true; 
                              }
                            }else{ //条件不满足
                              if(group.operator){
                                switch(group.operator){
                                  case "or":
                                    logic.result = logic.result || false;
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && false; 
                                  break;
                                }
                              }else{
                                logic.result = false;
                              }
                            }
                            // 如果比较完成后条件成立
                            if(gidx == logic.groups.length-1 && logic.result == true){
                              //循环把满足条件的题目显示
                              for(let i = 0; i<this.allQes.length;i++){            
                                if(this.allQes[i].qesId == logic.action.targetQesId){
                                  this.allQes[i].display = true;
                                  return;
                                }
                              }
                            }
                            // 如果比较完成后条件不成立
                            if(gidx == logic.groups.length-1 && logic.result == false){
                              //循环把满足条件的题目隐藏
                              for(let i = 0; i<this.allQes.length;i++){            
                                if(this.allQes[i].qesId == logic.action.targetQesId){
                                  this.allQes[i].display = false;
                                  return;
                                }
                              }
                            }
                          break;
                          // 所有选项被选择
                          case "select":
                            if(qesObj.showSelected){
                              let arr = qesObj.showSelected ? JSON.parse(qesObj.showSelected) : [];
                              //条件满足
                              if(qesObj.display && arr.length == qesObj.answers.length){ 
                                //判断是否为父条件(父条件值为null)
                                if(group.operator){
                                  //区分or与and逻辑比较
                                  switch(group.operator){
                                    case "or":
                                      //子条件与父条件用||比对
                                      logic.result = logic.result || true; 
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && true; 
                                    break;
                                  }
                                }else{
                                  //父条件成立并赋值
                                  logic.result = true; 
                                }
                              }else{ //条件不满足
                                if(group.operator){
                                  switch(group.operator){
                                    case "or":
                                      logic.result = logic.result || false;
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && false; 
                                    break;
                                  }
                                }else{
                                  logic.result = false;
                                }
                              }
                              // 如果比较完成后条件成立
                              // if(gidx == logic.groups.length-1 && logic.result == true){
                              //   console.log('=====条件满足======');
                              //   //循环把满足条件的题目显示
                              //   for(let i = 0; i<this.allQes.length;i++){            
                              //     if(this.allQes[i].qesId == logic.action.targetQesId){
                              //       this.allQes[i].display = true;
                              //       return;
                              //     }
                              //   }
                              // }
                              // 如果比较完成后条件不成立
                              if(gidx == logic.groups.length-1 && logic.result == false){
                                console.log('=====条件不满足======');
                                //循环把满足条件的题目隐藏
                                for(let i = 0; i<this.allQes.length;i++){            
                                  if(this.allQes[i].qesId == logic.action.targetQesId){
                                    this.allQes[i].display = false;
                                    return;
                                  }
                                }
                              }
                            }
                          break;
                        }
                      break;
                      // 范围->任一
                      case "any":
                        switch(group.data.operator){
                          // 任一选项输入的值大于
                          case "gt":
                            let gt = false;
                            qesObj.subQes.forEach(sub=>{
                              // 是否满足任一答案大于目标值
                              if(Number(sub.ansContent) > Number(group.data.extra)){
                                gt = true;
                                return;
                              }
                            })
                            //条件满足
                            if(gt){ 
                              //判断是否为父条件(父条件值为null)
                              if(group.operator){
                                //区分or与and逻辑比较
                                switch(group.operator){
                                  case "or":
                                    //子条件与父条件用||比对
                                    logic.result = logic.result || true; 
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && true; 
                                  break;
                                }
                              }else{
                                //父条件成立并赋值
                                logic.result = true; 
                              }
                            }else{ //条件不满足
                              if(group.operator){
                                switch(group.operator){
                                  case "or":
                                    logic.result = logic.result || false;
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && false; 
                                  break;
                                }
                              }else{
                                logic.result = false;
                              }
                            }
                            // 如果比较完成后条件成立
                            if(gidx == logic.groups.length-1 && logic.result == false){
                              //循环把满足条件的题目隐藏
                              for(let i = 0; i<this.allQes.length;i++){            
                                if(this.allQes[i].qesId == logic.action.targetQesId){
                                  this.allQes[i].display = false;
                                  return;
                                }
                              }
                            }
                          break;
                          // 任一选项输入的值等于
                          case "eq":
                            let eq = false;
                            qesObj.subQes.forEach(sub=>{
                              // 是否满足任一答案等于目标值
                              if(Number(sub.ansContent) == Number(group.data.extra)){
                                eq = true;
                                return;
                              }
                            })
                            //条件满足
                            if(eq){ 
                              //判断是否为父条件(父条件值为null)
                              if(group.operator){
                                //区分or与and逻辑比较
                                switch(group.operator){
                                  case "or":
                                    //子条件与父条件用||比对
                                    logic.result = logic.result || true; 
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && true; 
                                  break;
                                }
                              }else{
                                //父条件成立并赋值
                                logic.result = true; 
                              }
                            }else{ //条件不满足
                              if(group.operator){
                                switch(group.operator){
                                  case "or":
                                    logic.result = logic.result || false;
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && false; 
                                  break;
                                }
                              }else{
                                logic.result = false;
                              }
                            }
                            // 如果比较完成后条件成立
                            if(gidx == logic.groups.length-1 && logic.result == false){
                              //循环把满足条件的题目隐藏
                              for(let i = 0; i<this.allQes.length;i++){            
                                if(this.allQes[i].qesId == logic.action.targetQesId){
                                  this.allQes[i].display = false;
                                  return;
                                }
                              }
                            }
                          break;
                          // 任一选项输入的值小于
                          case "lt":
                            let lt = false;
                            qesObj.subQes.forEach(sub=>{
                              // 是否满足任一答案小于目标值
                              if(Number(sub.ansContent) < Number(group.data.extra)){
                                lt = true;
                                return;
                              }
                            })
                            //条件满足
                            if(lt){ 
                              //判断是否为父条件(父条件值为null)
                              if(group.operator){
                                //区分or与and逻辑比较
                                switch(group.operator){
                                  case "or":
                                    //子条件与父条件用||比对
                                    logic.result = logic.result || true; 
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && true; 
                                  break;
                                }
                              }else{
                                //父条件成立并赋值
                                logic.result = true; 
                              }
                            }else{ //条件不满足
                              if(group.operator){
                                switch(group.operator){
                                  case "or":
                                    logic.result = logic.result || false;
                                  break;
                                  case "and":
                                    //子条件与父条件用&&比对
                                    logic.result = logic.result && false; 
                                  break;
                                }
                              }else{
                                logic.result = false;
                              }
                            }
                            // 如果比较完成后条件成立
                            if(gidx == logic.groups.length-1 && logic.result == false){
                              //循环把满足条件的题目隐藏
                              for(let i = 0; i<this.allQes.length;i++){            
                                if(this.allQes[i].qesId == logic.action.targetQesId){
                                  this.allQes[i].display = false;
                                  return;
                                }
                              }
                            }
                          break;
                          // 任一选项被选择
                          case "select":
                            if(qesObj.showSelected){
                              let arr = JSON.parse(qesObj.showSelected);
                              //条件满足
                              if(arr.length > 0 && arr.length < qesObj.answers.length){ 
                                //判断是否为父条件(父条件值为null)
                                if(group.operator){
                                  //区分or与and逻辑比较
                                  switch(group.operator){
                                    case "or":
                                      //子条件与父条件用||比对
                                      logic.result = logic.result || true; 
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && true; 
                                    break;
                                  }
                                }else{
                                  //父条件成立并赋值
                                  logic.result = true; 
                                }
                              }else{ //条件不满足
                                if(group.operator){
                                  switch(group.operator){
                                    case "or":
                                      logic.result = logic.result || false;
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && false; 
                                    break;
                                  }
                                }else{
                                  logic.result = false;
                                }
                              }
                              // 如果比较完成后条件成立
                              if(gidx == logic.groups.length-1 && logic.result == false){
                                //循环把满足条件的题目隐藏
                                for(let i = 0; i<this.allQes.length;i++){            
                                  if(this.allQes[i].qesId == logic.action.targetQesId){
                                    this.allQes[i].display = false;
                                    return;
                                  }
                                }
                              }
                            }
                          break;
                        }
                      break;
                    }
                  break;
                  case "SUM":
                    if(qesObj.showSelected){
                      let arr = JSON.parse(qesObj.showSelected)
                      switch(group.data.prop.value){
                        // 选中数
                        case "selectCount":
                          switch(group.data.operator){
                            // 选中数大于目标值
                            case "gt":
                              //条件满足
                              if(arr.length > Number(group.data.extra)){ 
                                //判断是否为父条件(父条件值为null)
                                if(group.operator){
                                  //区分or与and逻辑比较
                                  switch(group.operator){
                                    case "or":
                                      //子条件与父条件用||比对
                                      logic.result = logic.result || true; 
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && true; 
                                    break;
                                  }
                                }else{
                                  //父条件成立并赋值
                                  logic.result = true; 
                                }
                              }else{ //条件不满足
                                if(group.operator){
                                  switch(group.operator){
                                    case "or":
                                      logic.result = logic.result || false;
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && false; 
                                    break;
                                  }
                                }else{
                                  logic.result = false;
                                }
                              }
                              // 如果比较完成后条件成立
                              if(gidx == logic.groups.length-1 && logic.result == false){
                                //循环把满足条件的题目隐藏
                                for(let i = 0; i<this.allQes.length;i++){            
                                  if(this.allQes[i].qesId == logic.action.targetQesId){
                                    this.allQes[i].display = false;
                                    return;
                                  }
                                }
                              }
                            break;
                            // 选中数等于目标值
                            case "eq":
                              //条件满足
                              if(arr.length == Number(group.data.extra)){ 
                                //判断是否为父条件(父条件值为null)
                                if(group.operator){
                                  //区分or与and逻辑比较
                                  switch(group.operator){
                                    case "or":
                                      //子条件与父条件用||比对
                                      logic.result = logic.result || true; 
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && true; 
                                    break;
                                  }
                                }else{
                                  //父条件成立并赋值
                                  logic.result = true; 
                                }
                              }else{ //条件不满足
                                if(group.operator){
                                  switch(group.operator){
                                    case "or":
                                      logic.result = logic.result || false;
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && false; 
                                    break;
                                  }
                                }else{
                                  logic.result = false;
                                }
                              }
                              // 如果比较完成后条件成立
                              if(gidx == logic.groups.length-1 && logic.result == false){
                                //循环把满足条件的题目隐藏
                                for(let i = 0; i<this.allQes.length;i++){            
                                  if(this.allQes[i].qesId == logic.action.targetQesId){
                                    this.allQes[i].display = false;
                                    return;
                                  }
                                }
                              }
                            break;
                            // 选中数小于目标值
                            case "lt":
                              //条件满足
                              if(arr.length < Number(group.data.extra)){ 
                                //判断是否为父条件(父条件值为null)
                                if(group.operator){
                                  //区分or与and逻辑比较
                                  switch(group.operator){
                                    case "or":
                                      //子条件与父条件用||比对
                                      logic.result = logic.result || true; 
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && true; 
                                    break;
                                  }
                                }else{
                                  //父条件成立并赋值
                                  logic.result = true; 
                                }
                              }else{ //条件不满足
                                if(group.operator){
                                  switch(group.operator){
                                    case "or":
                                      logic.result = logic.result || false;
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && false; 
                                    break;
                                  }
                                }else{
                                  logic.result = false;
                                }
                              }
                              // 如果比较完成后条件成立
                              if(gidx == logic.groups.length-1 && logic.result == false){
                                //循环把满足条件的题目隐藏
                                for(let i = 0; i<this.allQes.length;i++){            
                                  if(this.allQes[i].qesId == logic.action.targetQesId){
                                    this.allQes[i].display = false;
                                    return;
                                  }
                                }
                              }
                            break;
                          }
                        break;
                        // 未选中数
                        case "unselectCount":
                          let unCount = qesObj.answers.length - arr.length;
                          switch(group.data.operator){
                            // 未选中数大于目标值
                            case "gt":
                              //条件满足
                              if(unCount > Number(group.data.extra)){ 
                                //判断是否为父条件(父条件值为null)
                                if(group.operator){
                                  //区分or与and逻辑比较
                                  switch(group.operator){
                                    case "or":
                                      //子条件与父条件用||比对
                                      logic.result = logic.result || true; 
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && true; 
                                    break;
                                  }
                                }else{
                                  //父条件成立并赋值
                                  logic.result = true; 
                                }
                              }else{ //条件不满足
                                if(group.operator){
                                  switch(group.operator){
                                    case "or":
                                      logic.result = logic.result || false;
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && false; 
                                    break;
                                  }
                                }else{
                                  logic.result = false;
                                }
                              }
                              // 如果比较完成后条件成立
                              if(gidx == logic.groups.length-1 && logic.result == false){
                                //循环把满足条件的题目隐藏
                                for(let i = 0; i<this.allQes.length;i++){            
                                  if(this.allQes[i].qesId == logic.action.targetQesId){
                                    this.allQes[i].display = false;
                                    return;
                                  }
                                }
                              }
                            break;
                            // 未选中数等于目标值
                            case "eq":
                              //条件满足
                              if(unCount == Number(group.data.extra)){ 
                                //判断是否为父条件(父条件值为null)
                                if(group.operator){
                                  //区分or与and逻辑比较
                                  switch(group.operator){
                                    case "or":
                                      //子条件与父条件用||比对
                                      logic.result = logic.result || true; 
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && true; 
                                    break;
                                  }
                                }else{
                                  //父条件成立并赋值
                                  logic.result = true; 
                                }
                              }else{ //条件不满足
                                if(group.operator){
                                  switch(group.operator){
                                    case "or":
                                      logic.result = logic.result || false;
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && false; 
                                    break;
                                  }
                                }else{
                                  logic.result = false;
                                }
                              }
                              // 如果比较完成后条件成立
                              if(gidx == logic.groups.length-1 && logic.result == false){
                                //循环把满足条件的题目隐藏
                                for(let i = 0; i<this.allQes.length;i++){            
                                  if(this.allQes[i].qesId == logic.action.targetQesId){
                                    this.allQes[i].display = false;
                                    return;
                                  }
                                }
                              }
                            break;
                            // 未选中数小于目标值
                            case "lt":
                              //条件满足
                              if(unCount < Number(group.data.extra)){ 
                                //判断是否为父条件(父条件值为null)
                                if(group.operator){
                                  //区分or与and逻辑比较
                                  switch(group.operator){
                                    case "or":
                                      //子条件与父条件用||比对
                                      logic.result = logic.result || true; 
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && true; 
                                    break;
                                  }
                                }else{
                                  //父条件成立并赋值
                                  logic.result = true; 
                                }
                              }else{ //条件不满足
                                if(group.operator){
                                  switch(group.operator){
                                    case "or":
                                      logic.result = logic.result || false;
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && false; 
                                    break;
                                  }
                                }else{
                                  logic.result = false;
                                }
                              }
                              // 如果比较完成后条件成立
                              if(gidx == logic.groups.length-1 && logic.result == false){
                                //循环把满足条件的题目隐藏
                                for(let i = 0; i<this.allQes.length;i++){            
                                  if(this.allQes[i].qesId == logic.action.targetQesId){
                                    this.allQes[i].display = false;
                                    return;
                                  }
                                }
                              }
                            break;
                          }
                        break;
                      }
                    }
                  break;
                  case "VALUE":
                    if(qesObj.showSelected){
                      switch(group.data.operator){
                        // 输入的值大于目标值
                        case "gt":
                          //条件满足
                          if(Number(qesObj.showSelected) > Number(group.data.extra)){ 
                            //判断是否为父条件(父条件值为null)
                            if(group.operator){
                              //区分or与and逻辑比较
                              switch(group.operator){
                                case "or":
                                  //子条件与父条件用||比对
                                  logic.result = logic.result || true; 
                                break;
                                case "and":
                                  //子条件与父条件用&&比对
                                  logic.result = logic.result && true; 
                                break;
                              }
                            }else{
                              //父条件成立并赋值
                              logic.result = true; 
                            }
                          }else{ //条件不满足
                            if(group.operator){
                              switch(group.operator){
                                case "or":
                                  logic.result = logic.result || false;
                                break;
                                case "and":
                                  //子条件与父条件用&&比对
                                  logic.result = logic.result && false; 
                                break;
                              }
                            }else{
                              logic.result = false;
                            }
                          }
                          // 如果比较完成后条件成立
                          if(gidx == logic.groups.length-1 && logic.result == false){
                            //循环把满足条件的题目隐藏
                            for(let i = 0; i<this.allQes.length;i++){            
                              if(this.allQes[i].qesId == logic.action.targetQesId){
                                this.allQes[i].display = false;
                                return;
                              }
                            }
                          }
                        break;
                        // 输入的值等于目标值
                        case "eq":
                          //条件满足
                          if(Number(qesObj.showSelected) == Number(group.data.extra)){ 
                            //判断是否为父条件(父条件值为null)
                            if(group.operator){
                              //区分or与and逻辑比较
                              switch(group.operator){
                                case "or":
                                  //子条件与父条件用||比对
                                  logic.result = logic.result || true; 
                                break;
                                case "and":
                                  //子条件与父条件用&&比对
                                  logic.result = logic.result && true; 
                                break;
                              }
                            }else{
                              //父条件成立并赋值
                              logic.result = true; 
                            }
                          }else{ //条件不满足
                            if(group.operator){
                              switch(group.operator){
                                case "or":
                                  logic.result = logic.result || false;
                                break;
                                case "and":
                                  //子条件与父条件用&&比对
                                  logic.result = logic.result && false; 
                                break;
                              }
                            }else{
                              logic.result = false;
                            }
                          }
                          // 如果比较完成后条件成立
                          if(gidx == logic.groups.length-1 && logic.result == false){
                            //循环把满足条件的题目隐藏
                            for(let i = 0; i<this.allQes.length;i++){            
                              if(this.allQes[i].qesId == logic.action.targetQesId){
                                this.allQes[i].display = false;
                                return;
                              }
                            }
                          }
                        break;
                        // 输入的值小于目标值
                        case "lt":
                          //条件满足
                          if(Number(qesObj.showSelected) < Number(group.data.extra)){ 
                            //判断是否为父条件(父条件值为null)
                            if(group.operator){
                              //区分or与and逻辑比较
                              switch(group.operator){
                                case "or":
                                  //子条件与父条件用||比对
                                  logic.result = logic.result || true; 
                                break;
                                case "and":
                                  //子条件与父条件用&&比对
                                  logic.result = logic.result && true; 
                                break;
                              }
                            }else{
                              //父条件成立并赋值
                              logic.result = true; 
                            }
                          }else{ //条件不满足
                            if(group.operator){
                              switch(group.operator){
                                case "or":
                                  logic.result = logic.result || false;
                                break;
                                case "and":
                                  //子条件与父条件用&&比对
                                  logic.result = logic.result && false; 
                                break;
                              }
                            }else{
                              logic.result = false;
                            }
                          }
                          // 如果比较完成后条件成立
                          if(gidx == logic.groups.length-1 && logic.result == false){
                            //循环把满足条件的题目隐藏
                            for(let i = 0; i<this.allQes.length;i++){            
                              if(this.allQes[i].qesId == logic.action.targetQesId){
                                this.allQes[i].display = false;
                                return;
                              }
                            }
                          }
                        break;
                      }
                    }
                  break;
                  case "VALUE_KEY":
                    switch(group.data.operator){
                      // 选项输入的值大于
                      case "gt":
                        qesObj.subQes.forEach(sub=>{
                          //当前题答案与规则答案匹配
                          if(sub.qesId == group.data.prop.value){                                                              
                            // 填答有值的情况下进行解析
                            if(sub.ansContent){
                              //条件满足
                              if(Number(sub.ansContent) > Number(group.data.extra)){ 
                                //判断是否为父条件(父条件值为null)
                                if(group.operator){
                                  //区分or与and逻辑比较
                                  switch(group.operator){
                                    case "or":
                                      //子条件与父条件用||比对
                                      logic.result = logic.result || true; 
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && true; 
                                    break;
                                  }
                                }else{
                                  //父条件成立并赋值
                                  logic.result = true; 
                                }
                              }else{ //条件不满足
                                if(group.operator){
                                  switch(group.operator){
                                    case "or":
                                      logic.result = logic.result || false;
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && false; 
                                    break;
                                  }
                                }else{
                                  logic.result = false;
                                }
                              }
                              // 如果比较完成后条件成立
                              if(gidx == logic.groups.length-1 && logic.result == false){
                                //循环把满足条件的题目隐藏
                                for(let i = 0; i<this.allQes.length;i++){            
                                  if(this.allQes[i].qesId == logic.action.targetQesId){
                                    this.allQes[i].display = false;
                                    return;
                                  }
                                }
                              }
                            } 
                          }
                        })
                      break;
                      // 选项输入的值等于
                      case "eq":
                        qesObj.subQes.forEach(sub=>{
                          //当前题答案与规则答案匹配
                          if(sub.qesId == group.data.prop.value){                                                              
                            // 填答有值的情况下进行解析
                            if(sub.ansContent){
                              //条件满足
                              if(Number(sub.ansContent) == Number(group.data.extra)){ 
                                //判断是否为父条件(父条件值为null)
                                if(group.operator){
                                  //区分or与and逻辑比较
                                  switch(group.operator){
                                    case "or":
                                      //子条件与父条件用||比对
                                      logic.result = logic.result || true; 
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && true; 
                                    break;
                                  }
                                }else{
                                  //父条件成立并赋值
                                  logic.result = true; 
                                }
                              }else{ //条件不满足
                                if(group.operator){
                                  switch(group.operator){
                                    case "or":
                                      logic.result = logic.result || false;
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && false; 
                                    break;
                                  }
                                }else{
                                  logic.result = false;
                                }
                              }
                              // 如果比较完成后条件成立
                              if(gidx == logic.groups.length-1 && logic.result == false){
                                //循环把满足条件的题目隐藏
                                for(let i = 0; i<this.allQes.length;i++){            
                                  if(this.allQes[i].qesId == logic.action.targetQesId){
                                    this.allQes[i].display = false;
                                    return;
                                  }
                                }
                              }
                            } 
                          }
                        })
                      break;
                      // 选项输入的值小于
                      case "lt":
                        qesObj.subQes.forEach(sub=>{
                          //当前题答案与规则答案匹配                                                            
                          if(sub.qesId == group.data.prop.value){
                            // 填答有值的情况下进行解析
                            if(sub.ansContent){
                              //条件满足
                              if(Number(sub.ansContent) < Number(group.data.extra)){ 
                                //判断是否为父条件(父条件值为null)
                                if(group.operator){
                                  //区分or与and逻辑比较
                                  switch(group.operator){
                                    case "or":
                                      //子条件与父条件用||比对
                                      logic.result = logic.result || true; 
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && true; 
                                    break;
                                  }
                                }else{
                                  //父条件成立并赋值
                                  logic.result = true; 
                                }
                              }else{ //条件不满足
                                if(group.operator){
                                  switch(group.operator){
                                    case "or":
                                      logic.result = logic.result || false;
                                    break;
                                    case "and":
                                      //子条件与父条件用&&比对
                                      logic.result = logic.result && false; 
                                    break;
                                  }
                                }else{
                                  logic.result = false;
                                }
                              }
                              // 如果比较完成后条件成立
                              if(gidx == logic.groups.length-1 && logic.result == false){
                                //循环把满足条件的题目隐藏
                                for(let i = 0; i<this.allQes.length;i++){            
                                  if(this.allQes[i].qesId == logic.action.targetQesId){
                                    this.allQes[i].display = false;
                                    return;
                                  }
                                }
                              }
                            }                                                              
                          }
                        })
                      break;
                    }
                  break;
                }
              })
            }
          }
        })
      })
    },
    // 上一页
    prePage(){
      this.btnLoading = false;
      // 点击上一页面之前的页数
      let oldPage = this.currentPage;
      // 取出上一次的step
      this.currentPage = this.currentPage - 1 - this.historyStep[this.historyStep.length-1];
      console.log('console.log(this.historyStep.length);.........',this.currentPage);
      // 删除最后一次的步数记录
      this.historyStep.pop();
      console.log('console.log(this.historyStep.length);.........',this.currentPage);

      let index = this.currentPage;
      index = index - 1;
      console.log(this.currentPage,index);
      this.questionList = this.questions[index];
      for(let i = this.currentPage; i < oldPage;i++){
        this.questions[i].forEach(item=>{
          console.log('=============',item.qesName);
          item.display = true;
        })
      }
      window.scrollTo(0,0);
      console.log('点击上一页后的历史步数：',this.historyStep);
    },
    // 下一页
    nextPage(){
      console.log('selected:',this.selected);
      let off = this.isSubmit();
      // console.log(off);
      if(off){
        // 解析逻辑规则
        this.parseLogic();
        console.log(this.allQes,this.questionList);
        console.log('起始页：',this.currentPage,'起始步：',this.historyStep,'起始页问题',this.questions[this.currentPage - 1]);
        console.log('是否强制退出过',this.forceQuit);
        if(this.forceQuit){
          return;
        }
        // 下一页面执行
        this.btnLoading = true;
        // 临时步数,满足条件就+1
        let steps = 0;
        let show = false;
        for(let i = this.currentPage;i<this.totalPage;i++){
          // console.log(i,this.questions[i]);
          for(let j = 0;j<this.questions[i].length;j++){
            if(this.questions[i][j].display){
              show = true;
              break;
            }
          }
          // console.log(show,'当前页:',this.currentPage,'总页数：',this.totalPage);
          if(show == false){
            steps++;
          }else{
            break;
          }
        }
        // 存入最新一次的步数记录
        this.historyStep.push(steps);
        if(show == false && (this.currentPage+this.historyStep[this.historyStep.length-1]) == this.totalPage){
          // 提交
          this.submit();
        }

        this.currentPage++;
        this.currentPage = this.currentPage + this.historyStep[this.historyStep.length-1];
        console.log('当前页：',this.currentPage,'steps:',steps,'当前步：',this.historyStep,'当前页问题',this.questions[this.currentPage - 1]);
        this.surveyData.surveySubmit.currentPage = this.currentPage;    
        this.surveyData.surveySubmit.historyStep = this.historyStep;    
        this.surveyData.surveySubmit.qusetionSubmit = this.selected;
        let postData = {
          userId:this.userId,
          surveyId:this.surveyData.surveyInfo.surveyId,
          versionId:this.surveyData.surveyInfo.versionId,
          data:JSON.stringify(this.surveyData)
        }
        // console.log('下一页提交参数：',postData,this.surveyData.surveySubmit);
        this.$http.post('/survey/appSurvey/nextSurveyPage',postData,false,this.token).then(res=>{
          switch(res.code){
            case 200:
              this.btnLoading = false;
              let index = this.currentPage - 1;
              this.questionList = this.questions[index];
              // console.log(this.currentPage,index);
              window.scrollTo(0,0);
            break;
  
            case 10005:   // 问卷停用
              this.$router.push({
                path:'/statusPage',
                query:{
                  status:10005
                }
              })
            break;
  
            case 10006:  // 问卷已更新
              this.$router.push({
                path:'/statusPage',
                query:{
                  status:5
                }
              })
            break;
          }
        })
      }else{
        this.$toast.fail('本页有未回答的问题!');
      }
    },
    // 是否可提交
    isSubmit(){
      let off = true;
      let curselected = this.selected[this.currentPage-1];
      console.log('test',this.questionList,curselected);
      this.questionList.forEach((item,index)=>{
        if(curselected[index].qesId){          // 判断当前selected[index]对象是否为初始化没答案的状态
          if(item.display){
            switch(item.qesType){
              case "select":
                if(item.otherType == "multi"){
                  let ansExt = JSON.parse(curselected[index].ansExt);
                  console.log('+++++++++',ansExt);
                  let isAnswer = true;
                  let isSelect = false;
                  ansExt.forEach(ext=>{
                    if(ext.checked == 1){
                      isSelect = true;
                      if(ext.hasInput == 1){
                        if(!ext.ansInput){
                          isAnswer = false;
                        }
                      }
                    }
                  })
                  if(isAnswer == false || isSelect == false){
                    off = false;
                    return;
                  }
                }else{
                  if(!curselected[index].ansName){
                    off = false;
                    return;
                  }
                  if(curselected[index].hasInput == 1){
                    if(!curselected[index].textInput){
                      off = false;
                      return;
                    }
                  }
                }
              break;
    
              case "text":
                if(item.otherType == "multitermText"){
                  let subQes = JSON.parse(curselected[index].subQes);
                  subQes.forEach(sub=>{
                    // console.log(sub.ansContent);
                    if(!sub.ansContent){
                      off = false;
                      return;
                    }
                  })
                }else{
                  if(!curselected[index].ansName){
                    off = false;
                    return;
                  }
                }
              break;
            }
          }
        }else{
          if(item.display){
            off = false;
            return;
          }
        }
      });
      return off;
    },
    // 提交
    submit(){
      let off = this.isSubmit();
      if(off){
        this.btnLoading = true;
        this.surveyData.surveySubmit.qusetionSubmit = this.selected;
        this.surveyData.surveySubmit.submitStatus = 2;
        console.log(this.surveyData.surveySubmit);
        this.$http.post('/survey/appSurvey/submitSurvey',this.surveyData.surveySubmit,false,this.token).then(res=>{
          if(res.code == 200){
            this.btnLoading = false;
            this.$router.push({
              path:'/statusPage',
              query:{
                status:6,
                surveyShare:this.surveyShare,
                rewardAmount:res.data.rewardAmount,
                integralCount:res.data.integralCount
              }
            })
          }
        })
      }else{
        this.$toast.fail('本页有未回答的问题!');
      }
    },
    // 通过问题ID获取问题对象
    getQesObjByQesId(qesId){
      let obj = {};
      this.allQes.forEach((item,index)=>{
        if(item.qesId == qesId){
          obj = item;
        }
      })
      return obj;
    },
    // 没有通过校验强制退出问卷
    quitSurvey(){
      this.forceQuit = true;
      this.surveyData.surveySubmit.qusetionSubmit = this.selected;
      this.surveyData.surveySubmit.submitStatus = 1;
      this.$http.post('/survey/appSurvey/submitSurvey',this.surveyData.surveySubmit,false,this.token).then(res=>{
        if(res.code == 200){
          this.btnLoading = false;
          this.$router.push({
            path:'/statusPage',
            query:{
              status:10013,
              integralCount:res.data.integralCount,
              messageText:this.surveyConfig.errorText
            }
          })
        }
      })
    },
    // 返回到列表
    backToList(){
      this.showTimeEnd = false;
      location.href=`zwapp://back`;
      console.log("返回到列表");
    },
  }
}
</script>
<style lang="less" scoped>
.page{
  
  .survey{
    width: 100%;
    min-height: 100vh;
    background-color: #ffffff;
    border: 1px solid #e8eef1;
    border-radius: 6px;
    overflow: hidden;
    padding-bottom: 200px;
    position: relative;
    .page_jindu{
      height: 4px;
      width: 100%;
      display: flex;
      .jindu{
        flex: 1;
        background-color: #ffffff;
      }
    }
    .box_header{
      padding: 0 42px 40px;
      border-bottom: 2px solid #f2f2f2;
      .title{
        margin-top: 40px;
        width: 100%;
        text-align: center;
        font-size: 36px;
        font-weight: bold;
        color: #333333;
      }
      .desc{
        margin-top: 20px;
        width: 100%;
        font-size: 32px;
        line-height: 48px;
        color: #595959;
      }
    }
    .question_con{
      .bottom_navs{
        padding: 0 40px;
        box-sizing: border-box;
        display: flex;
      }
      .bottom_logo{
        position: absolute;
        left: 50%;
        bottom: 28px;
        margin-left: -150px;
        width: 300px;
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: center;
        .logo_img{
          width: 130px;
          height: 38px;
        }
        .logo_txt{
          font-size: 24px;
          color: #aaaaaa;
          margin-top: 18px;
        }
      }
    }
  }
  .start_answer{
    width: 100%;
    min-height: 100vh;
    padding: 33px 51px 68px 39px;
    box-sizing: border-box;
    background: url('../../assets/images/survey/start_answer_wrapper_bg.png') no-repeat;
    background-size: cover;
    .inner{
      width: 100%;
      height: 1105px;
      background: url('../../assets/images/survey/start_answer_inner_bg.png') no-repeat;
      background-size: contain;
      padding: 236px 29px 0 49px;
      box-sizing: border-box;
      .tips_box{
        .tips_tit{
          display: flex;
          align-items: center;
          .text{
            font-size: 48px;
            font-weight: bold;
            line-height: 67px;
            color: #0951B4;
          }
          .notes_icon{
            margin: 18px 0 0 10px;
            width: 60px;
            height: 50px;
          }
        }
        .tips_txt{
          margin-top: 10px;
          font-size: 32px;
          font-weight: bold;
          line-height: 45px;
          color: #0951B4;
        }
      }
      .bottom_box{
        margin-top: 86px;
        .rule_box{
          .time_box{
            display: flex;
            align-items: center;
            .time_icon{
              width: 47px;
              height: 47px;
            }
            .txt{
              margin-left: 10px;
              font-size: 28px;
              font-weight: bold;
              line-height: 40px;
              color: #0D65D6;
            }
            .danger_txt{
              font-size: 28px;
              font-weight: bold;
              line-height: 40px;
              color: #FF4C71;
            }
          }
          .money_box{
            margin-top: 20px;
            display: flex;
            align-items: center;
            .money_icon{
              width: 47px;
              height: 47px;
            }
            .txt{
              margin-left: 10px;
              font-size: 28px;
              font-weight: bold;
              line-height: 40px;
              color: #0D65D6;
            }
          }
        }
        .notice_box{
          margin-top: 36px;
          font-size: 28px;
          line-height: 42px;
          color: #7691B5;
          .txt{
            margin-top: 10px;
          }
        }
      }
      .start_btn{
        margin: 160px auto 0;
        width: 320px;
        height: 98px;
        font-size: 42px;
        font-weight: bold;
        line-height: 98px;
        text-align: center;
        color: #163FC0;
        background: #ffffff;
        border-radius: 49px;
        box-shadow: 3px 7px 8px 0px #063486, -4px -4px 17px 0px #7295eb inset; 
      }
    }
  }
  .end_pop{
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(0,0,0,.6);
    .inner{
      position: absolute;
      left: 50%;
      top: 20%;
      width: 522px;
      height: 554px;
      margin-left: -261px;
      background: url('../../assets/images/survey/answer_end_bg.png') no-repeat;
      background-size: contain;
      .tit{
        margin-top: 174px;
        text-align: center;
        font-size: 36px;
        font-weight: bold;
        line-height: 50px;
        color: #097BD2;
      }
      .txt{
        text-align: center;
        font-size: 28px;
        font-weight: 600;
        line-height: 48px;
        color: #333333;
        &.first{
          margin-top: 15px;
        }
      }
      .back_btn{
        margin: 65px auto 0;
        width: 230px;
        height: 68px;
        font-size: 28px;
        font-weight: bold;
        line-height: 68px;
        text-align: center;
        color: #FFFFFF;
        background: linear-gradient(147deg,#69a2ff 7%, #1878f3 86%);
        border-radius: 33px;
        box-shadow: 8px 9px 15px 0px rgba(46,131,246,0.24); 
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/survey/questionnaire.vue